"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Assets/Parameters Service
 * Set from Package Json
 *
 * The version of the OpenAPI document: 1.125.6
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParameterApi = exports.ParameterApiFactory = exports.ParameterApiFp = exports.ParameterApiAxiosParamCreator = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("../common");
// @ts-ignore
var base_1 = require("../base");
/**
 * ParameterApi - axios parameter creator
 * @export
 */
var ParameterApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Delete an asset. Assets may be restored through the PATCH endpoint.
         * @summary Soft delete an existing asset
         * @param {object} assetId Asset ID to retrieve a single asset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAsset: function (assetId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'assetId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteAsset', 'assetId', assetId);
                            localVarPath = "/assets/{asset_id}"
                                .replace("{".concat("asset_id", "}"), encodeURIComponent(String(assetId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete calculation link for given parameter_id and tag_id
         * @summary Delete calculation link
         * @param {object} parameterId The ID of the parameter to remove
         * @param {object} tagId the id of the tag to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCalculationLink: function (parameterId, tagId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'parameterId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteCalculationLink', 'parameterId', parameterId);
                            // verify required parameter 'tagId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteCalculationLink', 'tagId', tagId);
                            localVarPath = "/parameters/{parameter_id}/calculations/{tag_id}"
                                .replace("{".concat("parameter_id", "}"), encodeURIComponent(String(parameterId)))
                                .replace("{".concat("tag_id", "}"), encodeURIComponent(String(tagId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete category link for given parameter_id and tag_id
         * @summary Delete category link
         * @param {object} parameterId The ID of the parameter to remove
         * @param {object} tagId the id of the tag to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCategoryLink: function (parameterId, tagId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'parameterId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteCategoryLink', 'parameterId', parameterId);
                            // verify required parameter 'tagId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteCategoryLink', 'tagId', tagId);
                            localVarPath = "/parameters/{parameter_id}/categories/{tag_id}"
                                .replace("{".concat("parameter_id", "}"), encodeURIComponent(String(parameterId)))
                                .replace("{".concat("tag_id", "}"), encodeURIComponent(String(tagId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a data set. Data sets may be restored through the PATCH endpoint.
         * @summary Soft delete an existing data set
         * @param {object} dataSetId The ID of the Data Set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDataSet: function (dataSetId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'dataSetId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteDataSet', 'dataSetId', dataSetId);
                            localVarPath = "/data_sets/{data_set_id}"
                                .replace("{".concat("data_set_id", "}"), encodeURIComponent(String(dataSetId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete assets from to an existing data set.
         * @summary Delete assets from an existing data set.
         * @param {object} dataSetId The ID of the Data Set
         * @param {Array<string>} assetId List of Asset IDs to remove from the data set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDataSetAssets: function (dataSetId, assetId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'dataSetId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteDataSetAssets', 'dataSetId', dataSetId);
                            // verify required parameter 'assetId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteDataSetAssets', 'assetId', assetId);
                            localVarPath = "/data_sets/{data_set_id}/assets"
                                .replace("{".concat("data_set_id", "}"), encodeURIComponent(String(dataSetId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (assetId) {
                                localVarQueryParameter['asset_id'] = assetId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete an item type from the database by id. Note - deleting a global item type requires Admin privileges.
         * @summary Soft delete item type by id
         * @param {object} itemTypeId the id of the item type to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemType: function (itemTypeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'itemTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteItemType', 'itemTypeId', itemTypeId);
                            localVarPath = "/item_types/{item_type_id}"
                                .replace("{".concat("item_type_id", "}"), encodeURIComponent(String(itemTypeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Soft-deletes options of the given item_type
         * @summary Deletes options for given item_type - Note - deleting options for a global item type requires Admin privileges.
         * @param {object} itemTypeId Id of item_type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOptions: function (itemTypeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'itemTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteOptions', 'itemTypeId', itemTypeId);
                            localVarPath = "/item_types/{item_type_id}/options"
                                .replace("{".concat("item_type_id", "}"), encodeURIComponent(String(itemTypeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Marks the parameter with the current datetime as \"deleted_at\" allowing for later restore.
         * @summary Soft delete parameter by ID
         * @param {object} parameterId The ID of the parameter to remove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteParameter: function (parameterId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'parameterId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteParameter', 'parameterId', parameterId);
                            localVarPath = "/parameters/{parameter_id}"
                                .replace("{".concat("parameter_id", "}"), encodeURIComponent(String(parameterId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete link for given parameter_id and discipline_id
         * @summary Delete link for given parameter_id and discipline_id
         * @param {object} parameterId The ID of the parameter to remove
         * @param {object} tagId the id of the tag to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteParameterDiscipline: function (parameterId, tagId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'parameterId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteParameterDiscipline', 'parameterId', parameterId);
                            // verify required parameter 'tagId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteParameterDiscipline', 'tagId', tagId);
                            localVarPath = "/parameters/{parameter_id}/disciplines/{tag_id}"
                                .replace("{".concat("parameter_id", "}"), encodeURIComponent(String(parameterId)))
                                .replace("{".concat("tag_id", "}"), encodeURIComponent(String(tagId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete report link for given parameter_id and tag_id
         * @summary Delete report link
         * @param {object} parameterId The ID of the parameter to remove
         * @param {object} tagId the id of the tag to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReportLink: function (parameterId, tagId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'parameterId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteReportLink', 'parameterId', parameterId);
                            // verify required parameter 'tagId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteReportLink', 'tagId', tagId);
                            localVarPath = "/parameters/{parameter_id}/reports/{tag_id}"
                                .replace("{".concat("parameter_id", "}"), encodeURIComponent(String(parameterId)))
                                .replace("{".concat("tag_id", "}"), encodeURIComponent(String(tagId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns all asset type groups contained within the database
         * @summary Finds all asset_type_groups within the database - Route moved to Taxonomy Service
         * @param {Array<string>} [assetTypeGroupId] List of asset_type_group_ids to search by
         * @param {'name'} [sortBy] Field by which to sort projects by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAllAssetTypeGroups: function (assetTypeGroupId, sortBy, order, pageLimit, after, before, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/asset_type_groups";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (assetTypeGroupId) {
                                localVarQueryParameter['asset_type_group_id'] = assetTypeGroupId;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (pageLimit !== undefined) {
                                localVarQueryParameter['page_limit'] = pageLimit;
                            }
                            if (after !== undefined) {
                                localVarQueryParameter['after'] = after;
                            }
                            if (before !== undefined) {
                                localVarQueryParameter['before'] = before;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns all asset types contained within the database
         * @summary Finds all asset_types within the database - Route moved to Taxonomy Service
         * @param {Array<string>} [projectId] List of project_ids to search by
         * @param {Array<string>} [assetTypeId] List of asset_type_ids to search by
         * @param {Array<string>} [parentAssetId] List of parent_asset_ids to search by
         * @param {Array<string>} [assetTypeGroupId] List of asset_type_group_ids to search by
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort projects by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {string} [search] search for a source within the database
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAllAssetTypes: function (projectId, assetTypeId, parentAssetId, assetTypeGroupId, sortBy, order, pageLimit, after, before, search, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/asset_types";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (projectId) {
                                localVarQueryParameter['project_id'] = projectId;
                            }
                            if (assetTypeId) {
                                localVarQueryParameter['asset_type_id'] = assetTypeId;
                            }
                            if (parentAssetId) {
                                localVarQueryParameter['parent_asset_id'] = parentAssetId;
                            }
                            if (assetTypeGroupId) {
                                localVarQueryParameter['asset_type_group_id'] = assetTypeGroupId;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (pageLimit !== undefined) {
                                localVarQueryParameter['page_limit'] = pageLimit;
                            }
                            if (after !== undefined) {
                                localVarQueryParameter['after'] = after;
                            }
                            if (before !== undefined) {
                                localVarQueryParameter['before'] = before;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get all calculations for the current parameter
         * @summary Get all calculations
         * @param {object} parameterId The ID of the parameter to remove
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAllCalculations: function (parameterId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'parameterId' is not null or undefined
                            (0, common_1.assertParamExists)('getAllCalculations', 'parameterId', parameterId);
                            localVarPath = "/parameters/{parameter_id}/calculations"
                                .replace("{".concat("parameter_id", "}"), encodeURIComponent(String(parameterId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get all categories for the current parameter
         * @summary Get all categories
         * @param {object} parameterId The ID of the parameter to remove
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAllCategories: function (parameterId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'parameterId' is not null or undefined
                            (0, common_1.assertParamExists)('getAllCategories', 'parameterId', parameterId);
                            localVarPath = "/parameters/{parameter_id}/categories"
                                .replace("{".concat("parameter_id", "}"), encodeURIComponent(String(parameterId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get all item types
         * @summary Get all item types
         * @param {Array<string>} [itemTypeId] List of item_types_id to search by
         * @param {object} [parameterTypeId] parameter_type_id to search by
         * @param {object} [assetTypeId] asset_type_id to search by
         * @param {object} [notAssetTypeId] asset_type_id to exclude
         * @param {object} [assetSubTypeId] asset_sub_type_id to search by
         * @param {object} [notAssetSubTypeId] asset_sub_type_id to exclude
         * @param {boolean} [showGlobal] Flags whether to include global item_types in the response.
         * @param {boolean} [showLocal] Flags whether to include non-global item_types that are scoped to a project.
         * @param {string} [scopeId] The ID of the project to filter non-global item_types by. The response will include non-global item_types that are scoped to the project specified in the query. show_local must be set to true to show results of this query.
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {'created_at' | 'parameter_type_name'} [sortBy] created_at sorts by creation date of the parameter and parameter_type_name sorts by the name of the revisions parameter_type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllItemTypes: function (itemTypeId, parameterTypeId, assetTypeId, notAssetTypeId, assetSubTypeId, notAssetSubTypeId, showGlobal, showLocal, scopeId, order, pageLimit, after, before, sortBy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/item_types";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (itemTypeId) {
                                localVarQueryParameter['item_type_id'] = itemTypeId;
                            }
                            if (parameterTypeId !== undefined) {
                                localVarQueryParameter['parameter_type_id'] = parameterTypeId;
                            }
                            if (assetTypeId !== undefined) {
                                localVarQueryParameter['asset_type_id'] = assetTypeId;
                            }
                            if (notAssetTypeId !== undefined) {
                                localVarQueryParameter['not_asset_type_id'] = notAssetTypeId;
                            }
                            if (assetSubTypeId !== undefined) {
                                localVarQueryParameter['asset_sub_type_id'] = assetSubTypeId;
                            }
                            if (notAssetSubTypeId !== undefined) {
                                localVarQueryParameter['not_asset_sub_type_id'] = notAssetSubTypeId;
                            }
                            if (showGlobal !== undefined) {
                                localVarQueryParameter['show_global'] = showGlobal;
                            }
                            if (showLocal !== undefined) {
                                localVarQueryParameter['show_local'] = showLocal;
                            }
                            if (scopeId !== undefined) {
                                localVarQueryParameter['scope_id'] = scopeId;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (pageLimit !== undefined) {
                                localVarQueryParameter['page_limit'] = pageLimit;
                            }
                            if (after !== undefined) {
                                localVarQueryParameter['after'] = after;
                            }
                            if (before !== undefined) {
                                localVarQueryParameter['before'] = before;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get all disciplines for the current parameter
         * @summary Get all disciplines
         * @param {object} parameterId The ID of the parameter to remove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllParameterDisciplines: function (parameterId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'parameterId' is not null or undefined
                            (0, common_1.assertParamExists)('getAllParameterDisciplines', 'parameterId', parameterId);
                            localVarPath = "/parameters/{parameter_id}/disciplines"
                                .replace("{".concat("parameter_id", "}"), encodeURIComponent(String(parameterId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns all parameter types contained within the database
         * @summary Finds all parameter_types within the database - Route moved to Taxonomy Service
         * @param {object} [notAssetId] The ID of the asset to filter parameter_types by , will only return parameter_types that are not attached to the given asset_id
         * @param {object} [projectId] The ID of the project to filter parameter_types by, will only return parameter_types that have an existing parameter instance on the given project_id
         * @param {object} [notProjectId] The ID of the project to filter parameter_types by , will only return parameter_types that do not have an existing parameter instance on the given project_id
         * @param {object} [assetTypeId] The ID of the asset type to filter parameter_types by , will only return parameter_types that are attached to the given asset_type. An empty asset_type_id query will return parameter_types that have no asset_type associated with them (i.e. project level parameters)
         * @param {object} [assetSubTypeId] The ID of the asset sub type to filter parameter_types by , will only return parameter_types that are attached to the given asset_sub_type. An empty asset_sub_type_id query will return parameter_types that have no asset_sub_type associated with them (i.e. of asset type with no sub types or project level parameters)
         * @param {Array<string>} [parameterTypeId] Query by an array of parameter_type_id\&#39;s
         * @param {boolean} [showGlobal] Flags whether to include global parameter types in the response.
         * @param {boolean} [showLocal] Flags whether to include non-global parameter_types that are scoped to a project.
         * @param {string} [scopeId] The ID of the project to filter non-global parameter_types by. The response will include non-global parameter_types that are scoped to the project specified in the query. show_local must be set to true to show results of this query.
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort projects by
         * @param {Array<string>} [assetId] Asset ID(s) to filter by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {string} [search] search for a source within the database
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAllParameterTypes: function (notAssetId, projectId, notProjectId, assetTypeId, assetSubTypeId, parameterTypeId, showGlobal, showLocal, scopeId, sortBy, assetId, order, pageLimit, after, before, search, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/parameter_types";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (notAssetId !== undefined) {
                                localVarQueryParameter['not_asset_id'] = notAssetId;
                            }
                            if (projectId !== undefined) {
                                localVarQueryParameter['project_id'] = projectId;
                            }
                            if (notProjectId !== undefined) {
                                localVarQueryParameter['not_project_id'] = notProjectId;
                            }
                            if (assetTypeId !== undefined) {
                                localVarQueryParameter['asset_type_id'] = assetTypeId;
                            }
                            if (assetSubTypeId !== undefined) {
                                localVarQueryParameter['asset_sub_type_id'] = assetSubTypeId;
                            }
                            if (parameterTypeId) {
                                localVarQueryParameter['parameter_type_id'] = parameterTypeId;
                            }
                            if (showGlobal !== undefined) {
                                localVarQueryParameter['show_global'] = showGlobal;
                            }
                            if (showLocal !== undefined) {
                                localVarQueryParameter['show_local'] = showLocal;
                            }
                            if (scopeId !== undefined) {
                                localVarQueryParameter['scope_id'] = scopeId;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (assetId) {
                                localVarQueryParameter['asset_id'] = assetId;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (pageLimit !== undefined) {
                                localVarQueryParameter['page_limit'] = pageLimit;
                            }
                            if (after !== undefined) {
                                localVarQueryParameter['after'] = after;
                            }
                            if (before !== undefined) {
                                localVarQueryParameter['before'] = before;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns all parameters contained within the database. Queries are in the format `?query_name=[\"uuid1\", \"uuid2\"], where the array is in valid json format.
         * @summary Finds all parameters within the database
         * @param {Array<string>} [assetId] Asset ID(s) to filter by
         * @param {Array<string>} [assetType] Filters the parameters to those associated with the provided asset_type_ids
         * @param {Array<string>} [parameterId] Filters the parameters by the provided parameter ids
         * @param {Array<string>} [parameterTypeId] Filters the parameters to those associated with the provided parameter type ids
         * @param {Array<string>} [projectId] List of project_ids to search by
         * @param {boolean} [projectParameter] Filters parameters to only those without a parent asset
         * @param {Array<string>} [categoryId] Filters the parameters to those associated with the provided category ids
         * @param {Array<string>} [reportId] Filters the parameters to those associated with the provided report ids
         * @param {Array<string>} [disciplineId] Filters the parameters to those associated with the provided discipline ids
         * @param {Array<string>} [dataSetId] Filters parameters by the provided data_set_ids
         * @param {Array<string>} [parameterSetId] Filters parameters by the provided parameter_set_ids
         * @param {Array<string>} [sourceId] Filters the parameters to those associated with the provided source ids
         * @param {Array<string>} [sourceTypeId] Filters the parameters to those associated with the provided source type ids
         * @param {Array<'unanswered' | 'answered' | 'checked' | 'approved' | 'rejected'>} [qaStatus] Filters the parameters to those with the provided QA status
         * @param {Array<string>} [unitId] Filters the parameters to those associated with the provided unit ids
         * @param {Array<string>} [itemTypeId] Filters parameters by the provided item_type_ids
         * @param {'created_at' | 'revised_at' | 'parameter_type_name' | 'qa_status'} [sortBy] created_at sorts by creation date of the parameter, revised_at sorts by creation date of the revision, qa_status sorts by the parameter status, value sorts by the current value of the parameter, units sorts by the unit of the parameter and parameter_type_name sorts by the name of the revisions parameter_type
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {boolean} [showActive] Flags whether to include non-deleted (i.e. active) items in the response
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllParameters: function (assetId, assetType, parameterId, parameterTypeId, projectId, projectParameter, categoryId, reportId, disciplineId, dataSetId, parameterSetId, sourceId, sourceTypeId, qaStatus, unitId, itemTypeId, sortBy, order, pageLimit, after, before, showActive, showDeleted, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/parameters";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (assetId) {
                                localVarQueryParameter['asset_id'] = assetId;
                            }
                            if (assetType) {
                                localVarQueryParameter['asset_type'] = assetType;
                            }
                            if (parameterId) {
                                localVarQueryParameter['parameter_id'] = parameterId;
                            }
                            if (parameterTypeId) {
                                localVarQueryParameter['parameter_type_id'] = parameterTypeId;
                            }
                            if (projectId) {
                                localVarQueryParameter['project_id'] = projectId;
                            }
                            if (projectParameter !== undefined) {
                                localVarQueryParameter['project_parameter'] = projectParameter;
                            }
                            if (categoryId) {
                                localVarQueryParameter['category_id'] = categoryId;
                            }
                            if (reportId) {
                                localVarQueryParameter['report_id'] = reportId;
                            }
                            if (disciplineId) {
                                localVarQueryParameter['discipline_id'] = disciplineId;
                            }
                            if (dataSetId) {
                                localVarQueryParameter['data_set_id'] = dataSetId;
                            }
                            if (parameterSetId) {
                                localVarQueryParameter['parameter_set_id'] = parameterSetId;
                            }
                            if (sourceId) {
                                localVarQueryParameter['source_id'] = sourceId;
                            }
                            if (sourceTypeId) {
                                localVarQueryParameter['source_type_id'] = sourceTypeId;
                            }
                            if (qaStatus) {
                                localVarQueryParameter['qa_status'] = qaStatus;
                            }
                            if (unitId) {
                                localVarQueryParameter['unit_id'] = unitId;
                            }
                            if (itemTypeId) {
                                localVarQueryParameter['item_type_id'] = itemTypeId;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (pageLimit !== undefined) {
                                localVarQueryParameter['page_limit'] = pageLimit;
                            }
                            if (after !== undefined) {
                                localVarQueryParameter['after'] = after;
                            }
                            if (before !== undefined) {
                                localVarQueryParameter['before'] = before;
                            }
                            if (showActive !== undefined) {
                                localVarQueryParameter['show_active'] = showActive;
                            }
                            if (showDeleted !== undefined) {
                                localVarQueryParameter['show_deleted'] = showDeleted;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get all reports for the current parameter
         * @summary Get all reports
         * @param {object} parameterId The ID of the parameter to remove
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAllReports: function (parameterId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'parameterId' is not null or undefined
                            (0, common_1.assertParamExists)('getAllReports', 'parameterId', parameterId);
                            localVarPath = "/parameters/{parameter_id}/reports"
                                .replace("{".concat("parameter_id", "}"), encodeURIComponent(String(parameterId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns all units systems contained within the database. Unit systems are unique by name.
         * @summary Finds all unit systems within the database - Route moved to Taxonomy Service
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort projects by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAllUnitSystems: function (sortBy, order, pageLimit, after, before, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/unit_systems";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (pageLimit !== undefined) {
                                localVarQueryParameter['page_limit'] = pageLimit;
                            }
                            if (after !== undefined) {
                                localVarQueryParameter['after'] = after;
                            }
                            if (before !== undefined) {
                                localVarQueryParameter['before'] = before;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns all units types contained within the database. Unit types are unique by name. Note - the available unit types for a parameter type should be obtained from the parameter_types endpoint.
         * @summary Finds all unit types within the database - Route moved to Taxonomy Service
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort projects by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {Array<string>} [unitTypeId] Filters the unit types to those associated with the provided unit type ids
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAllUnitTypes: function (sortBy, order, pageLimit, after, before, unitTypeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/unit_types";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (pageLimit !== undefined) {
                                localVarQueryParameter['page_limit'] = pageLimit;
                            }
                            if (after !== undefined) {
                                localVarQueryParameter['after'] = after;
                            }
                            if (before !== undefined) {
                                localVarQueryParameter['before'] = before;
                            }
                            if (unitTypeId) {
                                localVarQueryParameter['unit_type_id'] = unitTypeId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns all units contained within the database. Units are unique by name. Note - the available units for a parameter type should be obtained from the parameter_types endpoint.
         * @summary Finds all units within the database - Route moved to Taxonomy Service
         * @param {Array<string>} [parameterTypeId] Filters the parameters to those associated with the provided parameter type ids
         * @param {'created_at' | 'symbol'} [sortBy] Field by which to sort projects by
         * @param {Array<string>} [assetId] Asset ID(s) to filter by
         * @param {Array<string>} [projectId] List of project_ids to search by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAllUnits: function (parameterTypeId, sortBy, assetId, projectId, order, pageLimit, after, before, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/units";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (parameterTypeId) {
                                localVarQueryParameter['parameter_type_id'] = parameterTypeId;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (assetId) {
                                localVarQueryParameter['asset_id'] = assetId;
                            }
                            if (projectId) {
                                localVarQueryParameter['project_id'] = projectId;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (pageLimit !== undefined) {
                                localVarQueryParameter['page_limit'] = pageLimit;
                            }
                            if (after !== undefined) {
                                localVarQueryParameter['after'] = after;
                            }
                            if (before !== undefined) {
                                localVarQueryParameter['before'] = before;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns asset by ID contained within the database
         * @summary Finds an asset within the database
         * @param {object} assetId Asset ID to retrieve a single asset
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAsset: function (assetId, showDeleted, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'assetId' is not null or undefined
                            (0, common_1.assertParamExists)('getAsset', 'assetId', assetId);
                            localVarPath = "/assets/{asset_id}"
                                .replace("{".concat("asset_id", "}"), encodeURIComponent(String(assetId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (showDeleted !== undefined) {
                                localVarQueryParameter['show_deleted'] = showDeleted;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns the ordered hierarchies of a given asset and its parents [great-grandparent, grandparent, parent, itself]
         * @summary Returns the ordered hierarchies of a given asset and its parents
         * @param {Array<string>} assetIds Asset IDs to retrieve the hierarchy of
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetHierarchy: function (assetIds, showDeleted, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'assetIds' is not null or undefined
                            (0, common_1.assertParamExists)('getAssetHierarchy', 'assetIds', assetIds);
                            localVarPath = "/assets/{asset_ids}/hierarchy"
                                .replace("{".concat("asset_ids", "}"), encodeURIComponent(String(assetIds)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (showDeleted !== undefined) {
                                localVarQueryParameter['show_deleted'] = showDeleted;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns all asset sub types related to the specified asset type contained within the database
         * @summary Finds all asset_sub_types related to the asset_type_id - Route moved to Taxonomy Service
         * @param {object} assetTypeId Asset_type_id to search by
         * @param {Array<string>} [assetSubTypeId] The asset_sub_type_id to search by
         * @param {object} [parentAssetSubTypeId] Unique ID of the asset sub type\&#39;s parent asset sub type (for example the variable temperature sub-system would have a parent of the hot water system)
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort asset_sub_types by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {string} [search] search for a source within the database
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAssetSubTypes: function (assetTypeId, assetSubTypeId, parentAssetSubTypeId, sortBy, order, pageLimit, after, before, search, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'assetTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('getAssetSubTypes', 'assetTypeId', assetTypeId);
                            localVarPath = "/asset_types/{asset_type_id}/asset_sub_types"
                                .replace("{".concat("asset_type_id", "}"), encodeURIComponent(String(assetTypeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (assetSubTypeId) {
                                localVarQueryParameter['asset_sub_type_id'] = assetSubTypeId;
                            }
                            if (parentAssetSubTypeId !== undefined) {
                                localVarQueryParameter['parent_asset_sub_type_id'] = parentAssetSubTypeId;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (pageLimit !== undefined) {
                                localVarQueryParameter['page_limit'] = pageLimit;
                            }
                            if (after !== undefined) {
                                localVarQueryParameter['after'] = after;
                            }
                            if (before !== undefined) {
                                localVarQueryParameter['before'] = before;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns all id, name, asset_type_id, and parent_asset_sub_type_id of  asset sub types related to the specified asset sub type ids contained within the database
         * @summary Finds all asset_sub_types associated with provided asset_sub_type_id - Route moved to Taxonomy Service
         * @param {Array<string>} [assetSubTypeId] The asset_sub_type_ids to search by
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort asset_sub_types by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {string} [search] search for a source within the database
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAssetSubTypesRef: function (assetSubTypeId, sortBy, order, pageLimit, after, before, search, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/asset_sub_types";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (assetSubTypeId) {
                                localVarQueryParameter['asset_sub_type_id'] = assetSubTypeId;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (pageLimit !== undefined) {
                                localVarQueryParameter['page_limit'] = pageLimit;
                            }
                            if (after !== undefined) {
                                localVarQueryParameter['after'] = after;
                            }
                            if (before !== undefined) {
                                localVarQueryParameter['before'] = before;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns all asset types contained within the database
         * @summary Gets an asset tree by asset_id within the database
         * @param {string} assetId asset_id to query by
         * @param {number} [depth] This is depth level at which the asset tree children are returned. Depth 1 would return the children of the asset queried. Depth 2 will include the children of the assets returned for depth 1. If depth is empty the full asset tree is returned.
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetTree: function (assetId, depth, showDeleted, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'assetId' is not null or undefined
                            (0, common_1.assertParamExists)('getAssetTree', 'assetId', assetId);
                            localVarPath = "/asset_tree";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (assetId !== undefined) {
                                localVarQueryParameter['asset_id'] = assetId;
                            }
                            if (depth !== undefined) {
                                localVarQueryParameter['depth'] = depth;
                            }
                            if (showDeleted !== undefined) {
                                localVarQueryParameter['show_deleted'] = showDeleted;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns parent, children, grandchildren etc. asset types contained within the database
         * @summary Gets an asset type tree by asset_type_id within the database - Route moved to Taxonomy Service
         * @param {Array<string>} assetTypeId List of asset_type_ids to query by
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAssetTypeTree: function (assetTypeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'assetTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('getAssetTypeTree', 'assetTypeId', assetTypeId);
                            localVarPath = "/asset_type_tree";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (assetTypeId) {
                                localVarQueryParameter['asset_type_id'] = assetTypeId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns all assets contained within the database
         * @summary Finds all assets within the database
         * @param {Array<string>} [assetId] List of asset_id\&#39;s to search by
         * @param {Array<string>} [assetTypeId] List of asset_type_id\&#39;s to search by
         * @param {Array<string>} [parentId] List of parent asset_id\&#39;s, filtering the assets to only the children of the assets provided
         * @param {Array<string>} [descendantsOf] Single asset_id, to filter the assets to only the children of the asset provided and their children.
         * @param {Array<string>} [projectId] List of project_ids to search by
         * @param {boolean} [showActive] Flags whether to include non-deleted (i.e. active) items in the response
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {'name'} [sortBy] name sorts by the name of the asset
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssets: function (assetId, assetTypeId, parentId, descendantsOf, projectId, showActive, showDeleted, sortBy, order, pageLimit, after, before, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/assets";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (assetId) {
                                localVarQueryParameter['asset_id'] = assetId;
                            }
                            if (assetTypeId) {
                                localVarQueryParameter['asset_type_id'] = assetTypeId;
                            }
                            if (parentId) {
                                localVarQueryParameter['parent_id'] = parentId;
                            }
                            if (descendantsOf) {
                                localVarQueryParameter['descendants_of'] = descendantsOf;
                            }
                            if (projectId) {
                                localVarQueryParameter['project_id'] = projectId;
                            }
                            if (showActive !== undefined) {
                                localVarQueryParameter['show_active'] = showActive;
                            }
                            if (showDeleted !== undefined) {
                                localVarQueryParameter['show_deleted'] = showDeleted;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (pageLimit !== undefined) {
                                localVarQueryParameter['page_limit'] = pageLimit;
                            }
                            if (after !== undefined) {
                                localVarQueryParameter['after'] = after;
                            }
                            if (before !== undefined) {
                                localVarQueryParameter['before'] = before;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get Calculation for given parameter_id and tag_id
         * @summary Get Calculation for given parameter_id and tag_id
         * @param {object} parameterId The ID of the parameter to remove
         * @param {object} tagId the id of the tag to search
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getCalculation: function (parameterId, tagId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'parameterId' is not null or undefined
                            (0, common_1.assertParamExists)('getCalculation', 'parameterId', parameterId);
                            // verify required parameter 'tagId' is not null or undefined
                            (0, common_1.assertParamExists)('getCalculation', 'tagId', tagId);
                            localVarPath = "/parameters/{parameter_id}/calculations/{tag_id}"
                                .replace("{".concat("parameter_id", "}"), encodeURIComponent(String(parameterId)))
                                .replace("{".concat("tag_id", "}"), encodeURIComponent(String(tagId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get Category for given parameter_id and tag_id
         * @summary Get Category for given parameter_id and tag_id
         * @param {object} parameterId The ID of the parameter to remove
         * @param {object} tagId the id of the tag to search
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getCategory: function (parameterId, tagId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'parameterId' is not null or undefined
                            (0, common_1.assertParamExists)('getCategory', 'parameterId', parameterId);
                            // verify required parameter 'tagId' is not null or undefined
                            (0, common_1.assertParamExists)('getCategory', 'tagId', tagId);
                            localVarPath = "/parameters/{parameter_id}/categories/{tag_id}"
                                .replace("{".concat("parameter_id", "}"), encodeURIComponent(String(parameterId)))
                                .replace("{".concat("tag_id", "}"), encodeURIComponent(String(tagId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns all assets contained within a single data set
         * @summary Get all assets contained within a dataset
         * @param {object} dataSetId The ID of the Data Set
         * @param {'name'} [sortBy] name sorts by the name of the asset
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {boolean} [showActive] Flags whether to include non-deleted (i.e. active) items in the response
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataSetAssets: function (dataSetId, sortBy, order, pageLimit, after, before, showActive, showDeleted, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'dataSetId' is not null or undefined
                            (0, common_1.assertParamExists)('getDataSetAssets', 'dataSetId', dataSetId);
                            localVarPath = "/data_sets/{data_set_id}/assets"
                                .replace("{".concat("data_set_id", "}"), encodeURIComponent(String(dataSetId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (pageLimit !== undefined) {
                                localVarQueryParameter['page_limit'] = pageLimit;
                            }
                            if (after !== undefined) {
                                localVarQueryParameter['after'] = after;
                            }
                            if (before !== undefined) {
                                localVarQueryParameter['before'] = before;
                            }
                            if (showActive !== undefined) {
                                localVarQueryParameter['show_active'] = showActive;
                            }
                            if (showDeleted !== undefined) {
                                localVarQueryParameter['show_deleted'] = showDeleted;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a single data set and a summary of if the data set structure is a valid representation of the template. The \"valid\" key returns a boolean indicating if the data set is in a valid state. The \"details\" key indicates where errors have occurred - \"incorrect_asset_count\" returns a list of placeholders with an incorrect number of assets assigned to the placeholder or placeholder and parent asset, \"missing_parameters\" returns a list of parameter types that are missing from a specified assets.
         * @summary Get a data set and its valid status
         * @param {object} dataSetId The ID of the Data Set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataSetValid: function (dataSetId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'dataSetId' is not null or undefined
                            (0, common_1.assertParamExists)('getDataSetValid', 'dataSetId', dataSetId);
                            localVarPath = "/data_sets/{data_set_id}/valid"
                                .replace("{".concat("data_set_id", "}"), encodeURIComponent(String(dataSetId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns all data sets contained within the database
         * @summary Get all data sets
         * @param {Array<string>} [templateId] List of template_ids to search by
         * @param {Array<string>} [projectId] List of project_ids to search by
         * @param {'name' | 'created_at'} [sortBy] name sorts by the name of the data set, created_at sorts by creation date of the data set
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {boolean} [showActive] Flags whether to include non-deleted (i.e. active) items in the response
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataSets: function (templateId, projectId, sortBy, order, pageLimit, after, before, showActive, showDeleted, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/data_sets";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (templateId) {
                                localVarQueryParameter['template_id'] = templateId;
                            }
                            if (projectId) {
                                localVarQueryParameter['project_id'] = projectId;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (pageLimit !== undefined) {
                                localVarQueryParameter['page_limit'] = pageLimit;
                            }
                            if (after !== undefined) {
                                localVarQueryParameter['after'] = after;
                            }
                            if (before !== undefined) {
                                localVarQueryParameter['before'] = before;
                            }
                            if (showActive !== undefined) {
                                localVarQueryParameter['show_active'] = showActive;
                            }
                            if (showDeleted !== undefined) {
                                localVarQueryParameter['show_deleted'] = showDeleted;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Gets all entries, queryable by parameter id
         * @summary Get all entries
         * @param {Array<string>} [parameterId] Query by an array of parameter_id\&#39;s
         * @param {Array<string>} [assetId] List of asset_id\&#39;s to search by
         * @param {Array<string>} [projectId] List of project_ids to search by
         * @param {'created_at' | 'updated_at'} [sortBy] created_at sorts by creation date of the entry, updated_at sorts by latest updated date of the entry
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntries: function (parameterId, assetId, projectId, sortBy, order, pageLimit, after, before, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/entries";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (parameterId) {
                                localVarQueryParameter['parameter_id'] = parameterId;
                            }
                            if (assetId) {
                                localVarQueryParameter['asset_id'] = assetId;
                            }
                            if (projectId) {
                                localVarQueryParameter['project_id'] = projectId;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (pageLimit !== undefined) {
                                localVarQueryParameter['page_limit'] = pageLimit;
                            }
                            if (after !== undefined) {
                                localVarQueryParameter['after'] = after;
                            }
                            if (before !== undefined) {
                                localVarQueryParameter['before'] = before;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Gets all revisions of an entry, arranged from newest to oldest
         * @summary Get all revisions associated with the specified entry_id
         * @param {object} entryId the id of the entry to search
         * @param {'created_at' | 'updated_at'} [sortBy] created_at sorts by creation date of the entry revision, updated_at sorts by latest updated date of the entry revision
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntryRevisions: function (entryId, sortBy, order, pageLimit, after, before, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'entryId' is not null or undefined
                            (0, common_1.assertParamExists)('getEntryRevisions', 'entryId', entryId);
                            localVarPath = "/entries/{entry_id}/revisions"
                                .replace("{".concat("entry_id", "}"), encodeURIComponent(String(entryId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (pageLimit !== undefined) {
                                localVarQueryParameter['page_limit'] = pageLimit;
                            }
                            if (after !== undefined) {
                                localVarQueryParameter['after'] = after;
                            }
                            if (before !== undefined) {
                                localVarQueryParameter['before'] = before;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * An endpoint for the permissions service OPA data load.
         * @summary Get asset data for the permissions service OPA load  (Application Admin only).
         * @param {Array<string>} [assetId] List of asset ids to search by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpaLoadAssets: function (assetId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/opa_load/assets";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (assetId) {
                                localVarQueryParameter['asset_id'] = assetId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * An endpoint for the permissions service OPA data load.
         * @summary Get data sets data for the permissions service OPA load  (Application Admin only).
         * @param {Array<string>} [dataSetId] List of data_set ids to search by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpaLoadDataSets: function (dataSetId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/opa_load/data_sets";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (dataSetId) {
                                localVarQueryParameter['data_set_id'] = dataSetId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * An endpoint for the permissions service OPA data load.
         * @summary Get parameter data for the permissions service OPA load  (Application Admin only).
         * @param {Array<string>} [parameterId] List of parameter ids to search by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpaLoadParameters: function (parameterId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/opa_load/parameters";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (parameterId) {
                                localVarQueryParameter['parameter_id'] = parameterId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * An endpoint for the permissions service OPA data load.
         * @summary Get revisions data for the permissions service OPA load  (Application Admin only).
         * @param {Array<string>} [revisionId] List of revision ids to search by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpaLoadRevisions: function (revisionId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/opa_load/revisions";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (revisionId) {
                                localVarQueryParameter['revision_id'] = revisionId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Lists all options for an item type
         * @summary Get all options for an item type
         * @param {object} itemTypeId Id of item_type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOptions: function (itemTypeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'itemTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('getOptions', 'itemTypeId', itemTypeId);
                            localVarPath = "/item_types/{item_type_id}/options"
                                .replace("{".concat("item_type_id", "}"), encodeURIComponent(String(itemTypeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns parameter by ID from the database.
         * @summary Finds parameter by ID
         * @param {object} parameterId The ID of the parameter to remove
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParameter: function (parameterId, showDeleted, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'parameterId' is not null or undefined
                            (0, common_1.assertParamExists)('getParameter', 'parameterId', parameterId);
                            localVarPath = "/parameters/{parameter_id}"
                                .replace("{".concat("parameter_id", "}"), encodeURIComponent(String(parameterId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (showDeleted !== undefined) {
                                localVarQueryParameter['show_deleted'] = showDeleted;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns all parameter type by ID from the database
         * @summary Finds all parameter_type by ID - Route moved to Taxonomy Service
         * @param {object} parameterTypeId The ID of the parameter type to search
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getParameterType: function (parameterTypeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'parameterTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('getParameterType', 'parameterTypeId', parameterTypeId);
                            localVarPath = "/parameter_types/{parameter_type_id}"
                                .replace("{".concat("parameter_type_id", "}"), encodeURIComponent(String(parameterTypeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns metadata for parameter statistics
         * @summary Parameter metadata for count and qa stats
         * @param {Array<string>} [assetId] Asset ID(s) to filter by
         * @param {Array<string>} [assetType] Filters the parameters to those associated with the provided asset_type_ids
         * @param {Array<string>} [parameterTypeId] Filters the parameters to those associated with the provided parameter type ids
         * @param {Array<string>} [projectId] List of project_ids to search by
         * @param {boolean} [projectParameter] Filters parameters to only those without a parent asset
         * @param {Array<string>} [categoryId] Filters the parameters to those associated with the provided category ids
         * @param {Array<string>} [reportId] Filters the parameters to those associated with the provided report ids
         * @param {Array<string>} [disciplineId] Filters the parameters to those associated with the provided discipline ids
         * @param {Array<string>} [parameterSetId] Filters the parameters to those associated with the provided parameter set ids
         * @param {Array<string>} [sourceId] Filters the parameters to those associated with the provided source ids
         * @param {Array<string>} [sourceTypeId] Filters the parameters to those associated with the provided source type ids
         * @param {Array<'unanswered' | 'answered' | 'checked' | 'approved' | 'rejected'>} [qaStatus] Filters the parameters to those with the provided QA status
         * @param {Array<string>} [unitId] Filters the parameters to those associated with the provided unit ids
         * @param {boolean} [showActive] Flags whether to include non-deleted (i.e. active) items in the response
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParametersStatistics: function (assetId, assetType, parameterTypeId, projectId, projectParameter, categoryId, reportId, disciplineId, parameterSetId, sourceId, sourceTypeId, qaStatus, unitId, showActive, showDeleted, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/parameters/statistics";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (assetId) {
                                localVarQueryParameter['asset_id'] = assetId;
                            }
                            if (assetType) {
                                localVarQueryParameter['asset_type'] = assetType;
                            }
                            if (parameterTypeId) {
                                localVarQueryParameter['parameter_type_id'] = parameterTypeId;
                            }
                            if (projectId) {
                                localVarQueryParameter['project_id'] = projectId;
                            }
                            if (projectParameter !== undefined) {
                                localVarQueryParameter['project_parameter'] = projectParameter;
                            }
                            if (categoryId) {
                                localVarQueryParameter['category_id'] = categoryId;
                            }
                            if (reportId) {
                                localVarQueryParameter['report_id'] = reportId;
                            }
                            if (disciplineId) {
                                localVarQueryParameter['discipline_id'] = disciplineId;
                            }
                            if (parameterSetId) {
                                localVarQueryParameter['parameter_set_id'] = parameterSetId;
                            }
                            if (sourceId) {
                                localVarQueryParameter['source_id'] = sourceId;
                            }
                            if (sourceTypeId) {
                                localVarQueryParameter['source_type_id'] = sourceTypeId;
                            }
                            if (qaStatus) {
                                localVarQueryParameter['qa_status'] = qaStatus;
                            }
                            if (unitId) {
                                localVarQueryParameter['unit_id'] = unitId;
                            }
                            if (showActive !== undefined) {
                                localVarQueryParameter['show_active'] = showActive;
                            }
                            if (showDeleted !== undefined) {
                                localVarQueryParameter['show_deleted'] = showDeleted;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get Report for given parameter_id and tag_id
         * @summary Get Report for given parameter_id and tag_id
         * @param {object} parameterId The ID of the parameter to remove
         * @param {object} tagId the id of the tag to search
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getReport: function (parameterId, tagId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'parameterId' is not null or undefined
                            (0, common_1.assertParamExists)('getReport', 'parameterId', parameterId);
                            // verify required parameter 'tagId' is not null or undefined
                            (0, common_1.assertParamExists)('getReport', 'tagId', tagId);
                            localVarPath = "/parameters/{parameter_id}/reports/{tag_id}"
                                .replace("{".concat("parameter_id", "}"), encodeURIComponent(String(parameterId)))
                                .replace("{".concat("tag_id", "}"), encodeURIComponent(String(tagId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns all units relating to the specified unit_type_id within the database. Units are grouped by their unit system.
         * @summary Finds a unit type\'s corresponding units - Route moved to Taxonomy Service
         * @param {object} unitTypeId Unique ID for a single unit type
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getUnitType: function (unitTypeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'unitTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('getUnitType', 'unitTypeId', unitTypeId);
                            localVarPath = "/unit_types/{unit_type_id}"
                                .replace("{".concat("unit_type_id", "}"), encodeURIComponent(String(unitTypeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update an asset. This endpoint can be used to update an asset name, or restore a  previously deleted asset. Note - name updates on assets that are asset sub type  instances is not allowed. Note -  you cannot restore an asset and update its name  simultaneously, to do this please send separate requests.
         * @summary Patch an existing asset
         * @param {object} assetId Asset ID to retrieve a single asset
         * @param {PatchAssetBody} patchAssetBody Asset name to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAsset: function (assetId, patchAssetBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'assetId' is not null or undefined
                            (0, common_1.assertParamExists)('patchAsset', 'assetId', assetId);
                            // verify required parameter 'patchAssetBody' is not null or undefined
                            (0, common_1.assertParamExists)('patchAsset', 'patchAssetBody', patchAssetBody);
                            localVarPath = "/assets/{asset_id}"
                                .replace("{".concat("asset_id", "}"), encodeURIComponent(String(assetId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchAssetBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update an existing asset type. Note - requires Admin privileges.
         * @summary Patch an existing asset type (Application Admin only) - Route moved to Taxonomy Service
         * @param {object} assetTypeId The ID of the asset type to search
         * @param {PatchAssetTypeBody} patchAssetTypeBody Updates for the asset type
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        patchAssetType: function (assetTypeId, patchAssetTypeBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'assetTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('patchAssetType', 'assetTypeId', assetTypeId);
                            // verify required parameter 'patchAssetTypeBody' is not null or undefined
                            (0, common_1.assertParamExists)('patchAssetType', 'patchAssetTypeBody', patchAssetTypeBody);
                            localVarPath = "/asset_types/{asset_type_id}"
                                .replace("{".concat("asset_type_id", "}"), encodeURIComponent(String(assetTypeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchAssetTypeBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update a data set. This endpoint can be used to update a data set name
         * @summary Patch an existing data set name
         * @param {object} dataSetId The ID of the Data Set
         * @param {PatchDataSetBody} patchDataSetBody Data set name to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDataSet: function (dataSetId, patchDataSetBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'dataSetId' is not null or undefined
                            (0, common_1.assertParamExists)('patchDataSet', 'dataSetId', dataSetId);
                            // verify required parameter 'patchDataSetBody' is not null or undefined
                            (0, common_1.assertParamExists)('patchDataSet', 'patchDataSetBody', patchDataSetBody);
                            localVarPath = "/data_sets/{data_set_id}"
                                .replace("{".concat("data_set_id", "}"), encodeURIComponent(String(dataSetId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchDataSetBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update an existing parameter type. Note - updating global parameter types (scope = null) requires Admin privileges.
         * @summary Patch existing parameter type - Route moved to Taxonomy Service
         * @param {object} parameterTypeId The ID of the parameter type to search
         * @param {PatchParameterTypeBody} patchParameterTypeBody Updates for parameter type. Note - updating the default unit  will also update the associated unit type
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        patchParameterType: function (parameterTypeId, patchParameterTypeBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'parameterTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('patchParameterType', 'parameterTypeId', parameterTypeId);
                            // verify required parameter 'patchParameterTypeBody' is not null or undefined
                            (0, common_1.assertParamExists)('patchParameterType', 'patchParameterTypeBody', patchParameterTypeBody);
                            localVarPath = "/parameter_types/{parameter_type_id}"
                                .replace("{".concat("parameter_type_id", "}"), encodeURIComponent(String(parameterTypeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchParameterTypeBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Updates the status of the latest entry revisions
         * @summary Update entry revisions
         * @param {PatchRevisionBody} patchRevisionBody Updates to be applied to the latest entry revisions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchRevisions: function (patchRevisionBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'patchRevisionBody' is not null or undefined
                            (0, common_1.assertParamExists)('patchRevisions', 'patchRevisionBody', patchRevisionBody);
                            localVarPath = "/revisions";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchRevisionBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates a new asset based on the input parameters
         * @summary Create a new asset
         * @param {PostAssetBody} postAssetBody Assets to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAsset: function (postAssetBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'postAssetBody' is not null or undefined
                            (0, common_1.assertParamExists)('postAsset', 'postAssetBody', postAssetBody);
                            localVarPath = "/assets";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postAssetBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates new asset sub types. Note - requires Admin privileges.
         * @summary Creates new asset sub types (Application Admin only) - Route moved to Taxonomy Service
         * @param {object} assetTypeId Asset_type_ids to search by
         * @param {PostAssetSubTypesBody} postAssetSubTypesBody New asset sub type details
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        postAssetSubTypes: function (assetTypeId, postAssetSubTypesBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'assetTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('postAssetSubTypes', 'assetTypeId', assetTypeId);
                            // verify required parameter 'postAssetSubTypesBody' is not null or undefined
                            (0, common_1.assertParamExists)('postAssetSubTypes', 'postAssetSubTypesBody', postAssetSubTypesBody);
                            localVarPath = "/asset_types/{asset_type_id}/asset_sub_types"
                                .replace("{".concat("asset_type_id", "}"), encodeURIComponent(String(assetTypeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postAssetSubTypesBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates an asset type group. Note - requires Admin privileges.
         * @summary Create a new asset type group (Application Admin only) - Route moved to Taxonomy Service
         * @param {PostAssetTypeGroupsBody} postAssetTypeGroupsBody New asset type details
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        postAssetTypeGroups: function (postAssetTypeGroupsBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'postAssetTypeGroupsBody' is not null or undefined
                            (0, common_1.assertParamExists)('postAssetTypeGroups', 'postAssetTypeGroupsBody', postAssetTypeGroupsBody);
                            localVarPath = "/asset_type_groups";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postAssetTypeGroupsBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates an asset type. Note - requires Admin privileges.
         * @summary Create a new asset type (Application Admin only) - Route moved to Taxonomy Service
         * @param {PostAssetTypesBody} postAssetTypesBody New asset type details
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        postAssetTypes: function (postAssetTypesBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'postAssetTypesBody' is not null or undefined
                            (0, common_1.assertParamExists)('postAssetTypes', 'postAssetTypesBody', postAssetTypesBody);
                            localVarPath = "/asset_types";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postAssetTypesBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates a new parameter tag link for a calculation
         * @summary Create a new calculation link
         * @param {object} parameterId The ID of the parameter to remove
         * @param {PostCalculationLinkBody} postCalculationLinkBody Provides the tag_id of the calculation to be linked
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCalculationLink: function (parameterId, postCalculationLinkBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'parameterId' is not null or undefined
                            (0, common_1.assertParamExists)('postCalculationLink', 'parameterId', parameterId);
                            // verify required parameter 'postCalculationLinkBody' is not null or undefined
                            (0, common_1.assertParamExists)('postCalculationLink', 'postCalculationLinkBody', postCalculationLinkBody);
                            localVarPath = "/parameters/{parameter_id}/calculations"
                                .replace("{".concat("parameter_id", "}"), encodeURIComponent(String(parameterId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postCalculationLinkBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates a new parameter tag link for a category
         * @summary Create a new category link
         * @param {object} parameterId The ID of the parameter to remove
         * @param {PostCategoryLinkBody} postCategoryLinkBody Provides the tag_id of the category to be linked
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCategoryLink: function (parameterId, postCategoryLinkBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'parameterId' is not null or undefined
                            (0, common_1.assertParamExists)('postCategoryLink', 'parameterId', parameterId);
                            // verify required parameter 'postCategoryLinkBody' is not null or undefined
                            (0, common_1.assertParamExists)('postCategoryLink', 'postCategoryLinkBody', postCategoryLinkBody);
                            localVarPath = "/parameters/{parameter_id}/categories"
                                .replace("{".concat("parameter_id", "}"), encodeURIComponent(String(parameterId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postCategoryLinkBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates a new data set based on the specified template. This endpoint creates the dataset and associates all the assets provided in the request body with it. The assets provided must be compliant with the asset_placeholders defined by the template. Any missing parameters from the assets, based on the parameter_placeholders defined in the template, are created automatically as part of this request.
         * @summary Create a new data set
         * @param {PutDataSetBody} putDataSetBody Data sets to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDataSet: function (putDataSetBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'putDataSetBody' is not null or undefined
                            (0, common_1.assertParamExists)('postDataSet', 'putDataSetBody', putDataSetBody);
                            localVarPath = "/data_sets";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(putDataSetBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Adds existing assets to an existing data set. This also creates new parameters and links existing parameters associated with the new data set assets.
         * @summary Adds assets to an existing data set.
         * @param {object} dataSetId The ID of the Data Set
         * @param {PostDataSetAssetBody} postDataSetAssetBody Assets to be added to the Data Set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDataSetAssets: function (dataSetId, postDataSetAssetBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'dataSetId' is not null or undefined
                            (0, common_1.assertParamExists)('postDataSetAssets', 'dataSetId', dataSetId);
                            // verify required parameter 'postDataSetAssetBody' is not null or undefined
                            (0, common_1.assertParamExists)('postDataSetAssets', 'postDataSetAssetBody', postDataSetAssetBody);
                            localVarPath = "/data_sets/{data_set_id}/assets"
                                .replace("{".concat("data_set_id", "}"), encodeURIComponent(String(dataSetId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postDataSetAssetBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates an item type.  Note - creating a global item type requires Admin privileges.
         * @summary Create a new item type
         * @param {PostItemTypesBody} postItemTypesBody New item type details. You must specify the asset_type_id if posting  with an asset_sub_type_id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postItemTypes: function (postItemTypesBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'postItemTypesBody' is not null or undefined
                            (0, common_1.assertParamExists)('postItemTypes', 'postItemTypesBody', postItemTypesBody);
                            localVarPath = "/item_types";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postItemTypesBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates new parameter link for a disciplines
         * @summary Create new discipline links
         * @param {object} parameterId The ID of the parameter to remove
         * @param {PostParameterDisciplinesBody} postParameterDisciplinesBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postParameterDisciplines: function (parameterId, postParameterDisciplinesBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'parameterId' is not null or undefined
                            (0, common_1.assertParamExists)('postParameterDisciplines', 'parameterId', parameterId);
                            // verify required parameter 'postParameterDisciplinesBody' is not null or undefined
                            (0, common_1.assertParamExists)('postParameterDisciplines', 'postParameterDisciplinesBody', postParameterDisciplinesBody);
                            localVarPath = "/parameters/{parameter_id}/disciplines"
                                .replace("{".concat("parameter_id", "}"), encodeURIComponent(String(parameterId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postParameterDisciplinesBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates new parameter types. Note - creating global parameter types (scope = null) requires Admin privileges.
         * @summary Creates new parameter types - Route moved to Taxonomy Service
         * @param {PostParameterTypesBody} postParameterTypesBody New parameter type details
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        postParameterTypes: function (postParameterTypesBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'postParameterTypesBody' is not null or undefined
                            (0, common_1.assertParamExists)('postParameterTypes', 'postParameterTypesBody', postParameterTypesBody);
                            localVarPath = "/parameter_types";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postParameterTypesBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates a list of new parameters
         * @summary Create a list of new parameters
         * @param {PostParametersBody} postParametersBody parameter to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postParameters: function (postParametersBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'postParametersBody' is not null or undefined
                            (0, common_1.assertParamExists)('postParameters', 'postParametersBody', postParametersBody);
                            localVarPath = "/parameters";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postParametersBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates a new parameter tag link for a report
         * @summary Create a new report link
         * @param {object} parameterId The ID of the parameter to remove
         * @param {PostReportLinkBody} postReportLinkBody Requires the tag_id used to link the new report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postReportLink: function (parameterId, postReportLinkBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'parameterId' is not null or undefined
                            (0, common_1.assertParamExists)('postReportLink', 'parameterId', parameterId);
                            // verify required parameter 'postReportLinkBody' is not null or undefined
                            (0, common_1.assertParamExists)('postReportLink', 'postReportLinkBody', postReportLinkBody);
                            localVarPath = "/parameters/{parameter_id}/reports"
                                .replace("{".concat("parameter_id", "}"), encodeURIComponent(String(parameterId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postReportLinkBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Posts new unit types. This can only be done by an administrator
         * @summary Create new units types. Note - requires Admin privileges. Route moved to Taxonomy Service
         * @param {PostUnitTypesBody} postUnitTypesBody Unit types to be added
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        postUnitTypes: function (postUnitTypesBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'postUnitTypesBody' is not null or undefined
                            (0, common_1.assertParamExists)('postUnitTypes', 'postUnitTypesBody', postUnitTypesBody);
                            localVarPath = "/unit_types";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postUnitTypesBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Posts new units. This can only be done by an administrator
         * @summary Create new units. Note - requires Admin privileges. Route moved to Taxonomy Service
         * @param {PostUnitsBody} postUnitsBody Units to be added
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        postUnits: function (postUnitsBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'postUnitsBody' is not null or undefined
                            (0, common_1.assertParamExists)('postUnits', 'postUnitsBody', postUnitsBody);
                            localVarPath = "/units";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postUnitsBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create or update one or more entries
         * @summary Create or update one or more entries
         * @param {PutEntriesBody} putEntriesBody parameter and entry details to be linked
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putEntries: function (putEntriesBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'putEntriesBody' is not null or undefined
                            (0, common_1.assertParamExists)('putEntries', 'putEntriesBody', putEntriesBody);
                            localVarPath = "/entries";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(putEntriesBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Overwrites options for a given item_type by deleting the existing and adding new
         * @summary Sets options for given item_type - Note - creating options for a global item type requires Admin privileges.
         * @param {object} itemTypeId Id of item_type
         * @param {PutOptionsRequest} putOptionsRequest List of values (each value is an object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putOptions: function (itemTypeId, putOptionsRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'itemTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('putOptions', 'itemTypeId', itemTypeId);
                            // verify required parameter 'putOptionsRequest' is not null or undefined
                            (0, common_1.assertParamExists)('putOptions', 'putOptionsRequest', putOptionsRequest);
                            localVarPath = "/item_types/{item_type_id}/options"
                                .replace("{".concat("item_type_id", "}"), encodeURIComponent(String(itemTypeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(putOptionsRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ParameterApiAxiosParamCreator = ParameterApiAxiosParamCreator;
/**
 * ParameterApi - functional programming interface
 * @export
 */
var ParameterApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ParameterApiAxiosParamCreator)(configuration);
    return {
        /**
         * Delete an asset. Assets may be restored through the PATCH endpoint.
         * @summary Soft delete an existing asset
         * @param {object} assetId Asset ID to retrieve a single asset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAsset: function (assetId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteAsset(assetId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete calculation link for given parameter_id and tag_id
         * @summary Delete calculation link
         * @param {object} parameterId The ID of the parameter to remove
         * @param {object} tagId the id of the tag to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCalculationLink: function (parameterId, tagId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteCalculationLink(parameterId, tagId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete category link for given parameter_id and tag_id
         * @summary Delete category link
         * @param {object} parameterId The ID of the parameter to remove
         * @param {object} tagId the id of the tag to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCategoryLink: function (parameterId, tagId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteCategoryLink(parameterId, tagId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete a data set. Data sets may be restored through the PATCH endpoint.
         * @summary Soft delete an existing data set
         * @param {object} dataSetId The ID of the Data Set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDataSet: function (dataSetId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteDataSet(dataSetId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete assets from to an existing data set.
         * @summary Delete assets from an existing data set.
         * @param {object} dataSetId The ID of the Data Set
         * @param {Array<string>} assetId List of Asset IDs to remove from the data set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDataSetAssets: function (dataSetId, assetId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteDataSetAssets(dataSetId, assetId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete an item type from the database by id. Note - deleting a global item type requires Admin privileges.
         * @summary Soft delete item type by id
         * @param {object} itemTypeId the id of the item type to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemType: function (itemTypeId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteItemType(itemTypeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Soft-deletes options of the given item_type
         * @summary Deletes options for given item_type - Note - deleting options for a global item type requires Admin privileges.
         * @param {object} itemTypeId Id of item_type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOptions: function (itemTypeId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteOptions(itemTypeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Marks the parameter with the current datetime as \"deleted_at\" allowing for later restore.
         * @summary Soft delete parameter by ID
         * @param {object} parameterId The ID of the parameter to remove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteParameter: function (parameterId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteParameter(parameterId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete link for given parameter_id and discipline_id
         * @summary Delete link for given parameter_id and discipline_id
         * @param {object} parameterId The ID of the parameter to remove
         * @param {object} tagId the id of the tag to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteParameterDiscipline: function (parameterId, tagId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteParameterDiscipline(parameterId, tagId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete report link for given parameter_id and tag_id
         * @summary Delete report link
         * @param {object} parameterId The ID of the parameter to remove
         * @param {object} tagId the id of the tag to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReportLink: function (parameterId, tagId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteReportLink(parameterId, tagId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all asset type groups contained within the database
         * @summary Finds all asset_type_groups within the database - Route moved to Taxonomy Service
         * @param {Array<string>} [assetTypeGroupId] List of asset_type_group_ids to search by
         * @param {'name'} [sortBy] Field by which to sort projects by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAllAssetTypeGroups: function (assetTypeGroupId, sortBy, order, pageLimit, after, before, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllAssetTypeGroups(assetTypeGroupId, sortBy, order, pageLimit, after, before, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all asset types contained within the database
         * @summary Finds all asset_types within the database - Route moved to Taxonomy Service
         * @param {Array<string>} [projectId] List of project_ids to search by
         * @param {Array<string>} [assetTypeId] List of asset_type_ids to search by
         * @param {Array<string>} [parentAssetId] List of parent_asset_ids to search by
         * @param {Array<string>} [assetTypeGroupId] List of asset_type_group_ids to search by
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort projects by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {string} [search] search for a source within the database
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAllAssetTypes: function (projectId, assetTypeId, parentAssetId, assetTypeGroupId, sortBy, order, pageLimit, after, before, search, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllAssetTypes(projectId, assetTypeId, parentAssetId, assetTypeGroupId, sortBy, order, pageLimit, after, before, search, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all calculations for the current parameter
         * @summary Get all calculations
         * @param {object} parameterId The ID of the parameter to remove
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAllCalculations: function (parameterId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllCalculations(parameterId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all categories for the current parameter
         * @summary Get all categories
         * @param {object} parameterId The ID of the parameter to remove
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAllCategories: function (parameterId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllCategories(parameterId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all item types
         * @summary Get all item types
         * @param {Array<string>} [itemTypeId] List of item_types_id to search by
         * @param {object} [parameterTypeId] parameter_type_id to search by
         * @param {object} [assetTypeId] asset_type_id to search by
         * @param {object} [notAssetTypeId] asset_type_id to exclude
         * @param {object} [assetSubTypeId] asset_sub_type_id to search by
         * @param {object} [notAssetSubTypeId] asset_sub_type_id to exclude
         * @param {boolean} [showGlobal] Flags whether to include global item_types in the response.
         * @param {boolean} [showLocal] Flags whether to include non-global item_types that are scoped to a project.
         * @param {string} [scopeId] The ID of the project to filter non-global item_types by. The response will include non-global item_types that are scoped to the project specified in the query. show_local must be set to true to show results of this query.
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {'created_at' | 'parameter_type_name'} [sortBy] created_at sorts by creation date of the parameter and parameter_type_name sorts by the name of the revisions parameter_type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllItemTypes: function (itemTypeId, parameterTypeId, assetTypeId, notAssetTypeId, assetSubTypeId, notAssetSubTypeId, showGlobal, showLocal, scopeId, order, pageLimit, after, before, sortBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllItemTypes(itemTypeId, parameterTypeId, assetTypeId, notAssetTypeId, assetSubTypeId, notAssetSubTypeId, showGlobal, showLocal, scopeId, order, pageLimit, after, before, sortBy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all disciplines for the current parameter
         * @summary Get all disciplines
         * @param {object} parameterId The ID of the parameter to remove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllParameterDisciplines: function (parameterId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllParameterDisciplines(parameterId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all parameter types contained within the database
         * @summary Finds all parameter_types within the database - Route moved to Taxonomy Service
         * @param {object} [notAssetId] The ID of the asset to filter parameter_types by , will only return parameter_types that are not attached to the given asset_id
         * @param {object} [projectId] The ID of the project to filter parameter_types by, will only return parameter_types that have an existing parameter instance on the given project_id
         * @param {object} [notProjectId] The ID of the project to filter parameter_types by , will only return parameter_types that do not have an existing parameter instance on the given project_id
         * @param {object} [assetTypeId] The ID of the asset type to filter parameter_types by , will only return parameter_types that are attached to the given asset_type. An empty asset_type_id query will return parameter_types that have no asset_type associated with them (i.e. project level parameters)
         * @param {object} [assetSubTypeId] The ID of the asset sub type to filter parameter_types by , will only return parameter_types that are attached to the given asset_sub_type. An empty asset_sub_type_id query will return parameter_types that have no asset_sub_type associated with them (i.e. of asset type with no sub types or project level parameters)
         * @param {Array<string>} [parameterTypeId] Query by an array of parameter_type_id\&#39;s
         * @param {boolean} [showGlobal] Flags whether to include global parameter types in the response.
         * @param {boolean} [showLocal] Flags whether to include non-global parameter_types that are scoped to a project.
         * @param {string} [scopeId] The ID of the project to filter non-global parameter_types by. The response will include non-global parameter_types that are scoped to the project specified in the query. show_local must be set to true to show results of this query.
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort projects by
         * @param {Array<string>} [assetId] Asset ID(s) to filter by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {string} [search] search for a source within the database
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAllParameterTypes: function (notAssetId, projectId, notProjectId, assetTypeId, assetSubTypeId, parameterTypeId, showGlobal, showLocal, scopeId, sortBy, assetId, order, pageLimit, after, before, search, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllParameterTypes(notAssetId, projectId, notProjectId, assetTypeId, assetSubTypeId, parameterTypeId, showGlobal, showLocal, scopeId, sortBy, assetId, order, pageLimit, after, before, search, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all parameters contained within the database. Queries are in the format `?query_name=[\"uuid1\", \"uuid2\"], where the array is in valid json format.
         * @summary Finds all parameters within the database
         * @param {Array<string>} [assetId] Asset ID(s) to filter by
         * @param {Array<string>} [assetType] Filters the parameters to those associated with the provided asset_type_ids
         * @param {Array<string>} [parameterId] Filters the parameters by the provided parameter ids
         * @param {Array<string>} [parameterTypeId] Filters the parameters to those associated with the provided parameter type ids
         * @param {Array<string>} [projectId] List of project_ids to search by
         * @param {boolean} [projectParameter] Filters parameters to only those without a parent asset
         * @param {Array<string>} [categoryId] Filters the parameters to those associated with the provided category ids
         * @param {Array<string>} [reportId] Filters the parameters to those associated with the provided report ids
         * @param {Array<string>} [disciplineId] Filters the parameters to those associated with the provided discipline ids
         * @param {Array<string>} [dataSetId] Filters parameters by the provided data_set_ids
         * @param {Array<string>} [parameterSetId] Filters parameters by the provided parameter_set_ids
         * @param {Array<string>} [sourceId] Filters the parameters to those associated with the provided source ids
         * @param {Array<string>} [sourceTypeId] Filters the parameters to those associated with the provided source type ids
         * @param {Array<'unanswered' | 'answered' | 'checked' | 'approved' | 'rejected'>} [qaStatus] Filters the parameters to those with the provided QA status
         * @param {Array<string>} [unitId] Filters the parameters to those associated with the provided unit ids
         * @param {Array<string>} [itemTypeId] Filters parameters by the provided item_type_ids
         * @param {'created_at' | 'revised_at' | 'parameter_type_name' | 'qa_status'} [sortBy] created_at sorts by creation date of the parameter, revised_at sorts by creation date of the revision, qa_status sorts by the parameter status, value sorts by the current value of the parameter, units sorts by the unit of the parameter and parameter_type_name sorts by the name of the revisions parameter_type
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {boolean} [showActive] Flags whether to include non-deleted (i.e. active) items in the response
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllParameters: function (assetId, assetType, parameterId, parameterTypeId, projectId, projectParameter, categoryId, reportId, disciplineId, dataSetId, parameterSetId, sourceId, sourceTypeId, qaStatus, unitId, itemTypeId, sortBy, order, pageLimit, after, before, showActive, showDeleted, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllParameters(assetId, assetType, parameterId, parameterTypeId, projectId, projectParameter, categoryId, reportId, disciplineId, dataSetId, parameterSetId, sourceId, sourceTypeId, qaStatus, unitId, itemTypeId, sortBy, order, pageLimit, after, before, showActive, showDeleted, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all reports for the current parameter
         * @summary Get all reports
         * @param {object} parameterId The ID of the parameter to remove
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAllReports: function (parameterId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllReports(parameterId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all units systems contained within the database. Unit systems are unique by name.
         * @summary Finds all unit systems within the database - Route moved to Taxonomy Service
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort projects by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAllUnitSystems: function (sortBy, order, pageLimit, after, before, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllUnitSystems(sortBy, order, pageLimit, after, before, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all units types contained within the database. Unit types are unique by name. Note - the available unit types for a parameter type should be obtained from the parameter_types endpoint.
         * @summary Finds all unit types within the database - Route moved to Taxonomy Service
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort projects by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {Array<string>} [unitTypeId] Filters the unit types to those associated with the provided unit type ids
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAllUnitTypes: function (sortBy, order, pageLimit, after, before, unitTypeId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllUnitTypes(sortBy, order, pageLimit, after, before, unitTypeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all units contained within the database. Units are unique by name. Note - the available units for a parameter type should be obtained from the parameter_types endpoint.
         * @summary Finds all units within the database - Route moved to Taxonomy Service
         * @param {Array<string>} [parameterTypeId] Filters the parameters to those associated with the provided parameter type ids
         * @param {'created_at' | 'symbol'} [sortBy] Field by which to sort projects by
         * @param {Array<string>} [assetId] Asset ID(s) to filter by
         * @param {Array<string>} [projectId] List of project_ids to search by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAllUnits: function (parameterTypeId, sortBy, assetId, projectId, order, pageLimit, after, before, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllUnits(parameterTypeId, sortBy, assetId, projectId, order, pageLimit, after, before, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns asset by ID contained within the database
         * @summary Finds an asset within the database
         * @param {object} assetId Asset ID to retrieve a single asset
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAsset: function (assetId, showDeleted, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAsset(assetId, showDeleted, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns the ordered hierarchies of a given asset and its parents [great-grandparent, grandparent, parent, itself]
         * @summary Returns the ordered hierarchies of a given asset and its parents
         * @param {Array<string>} assetIds Asset IDs to retrieve the hierarchy of
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetHierarchy: function (assetIds, showDeleted, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAssetHierarchy(assetIds, showDeleted, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all asset sub types related to the specified asset type contained within the database
         * @summary Finds all asset_sub_types related to the asset_type_id - Route moved to Taxonomy Service
         * @param {object} assetTypeId Asset_type_id to search by
         * @param {Array<string>} [assetSubTypeId] The asset_sub_type_id to search by
         * @param {object} [parentAssetSubTypeId] Unique ID of the asset sub type\&#39;s parent asset sub type (for example the variable temperature sub-system would have a parent of the hot water system)
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort asset_sub_types by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {string} [search] search for a source within the database
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAssetSubTypes: function (assetTypeId, assetSubTypeId, parentAssetSubTypeId, sortBy, order, pageLimit, after, before, search, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAssetSubTypes(assetTypeId, assetSubTypeId, parentAssetSubTypeId, sortBy, order, pageLimit, after, before, search, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all id, name, asset_type_id, and parent_asset_sub_type_id of  asset sub types related to the specified asset sub type ids contained within the database
         * @summary Finds all asset_sub_types associated with provided asset_sub_type_id - Route moved to Taxonomy Service
         * @param {Array<string>} [assetSubTypeId] The asset_sub_type_ids to search by
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort asset_sub_types by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {string} [search] search for a source within the database
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAssetSubTypesRef: function (assetSubTypeId, sortBy, order, pageLimit, after, before, search, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAssetSubTypesRef(assetSubTypeId, sortBy, order, pageLimit, after, before, search, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all asset types contained within the database
         * @summary Gets an asset tree by asset_id within the database
         * @param {string} assetId asset_id to query by
         * @param {number} [depth] This is depth level at which the asset tree children are returned. Depth 1 would return the children of the asset queried. Depth 2 will include the children of the assets returned for depth 1. If depth is empty the full asset tree is returned.
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetTree: function (assetId, depth, showDeleted, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAssetTree(assetId, depth, showDeleted, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns parent, children, grandchildren etc. asset types contained within the database
         * @summary Gets an asset type tree by asset_type_id within the database - Route moved to Taxonomy Service
         * @param {Array<string>} assetTypeId List of asset_type_ids to query by
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAssetTypeTree: function (assetTypeId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAssetTypeTree(assetTypeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all assets contained within the database
         * @summary Finds all assets within the database
         * @param {Array<string>} [assetId] List of asset_id\&#39;s to search by
         * @param {Array<string>} [assetTypeId] List of asset_type_id\&#39;s to search by
         * @param {Array<string>} [parentId] List of parent asset_id\&#39;s, filtering the assets to only the children of the assets provided
         * @param {Array<string>} [descendantsOf] Single asset_id, to filter the assets to only the children of the asset provided and their children.
         * @param {Array<string>} [projectId] List of project_ids to search by
         * @param {boolean} [showActive] Flags whether to include non-deleted (i.e. active) items in the response
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {'name'} [sortBy] name sorts by the name of the asset
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssets: function (assetId, assetTypeId, parentId, descendantsOf, projectId, showActive, showDeleted, sortBy, order, pageLimit, after, before, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAssets(assetId, assetTypeId, parentId, descendantsOf, projectId, showActive, showDeleted, sortBy, order, pageLimit, after, before, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get Calculation for given parameter_id and tag_id
         * @summary Get Calculation for given parameter_id and tag_id
         * @param {object} parameterId The ID of the parameter to remove
         * @param {object} tagId the id of the tag to search
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getCalculation: function (parameterId, tagId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCalculation(parameterId, tagId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get Category for given parameter_id and tag_id
         * @summary Get Category for given parameter_id and tag_id
         * @param {object} parameterId The ID of the parameter to remove
         * @param {object} tagId the id of the tag to search
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getCategory: function (parameterId, tagId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCategory(parameterId, tagId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all assets contained within a single data set
         * @summary Get all assets contained within a dataset
         * @param {object} dataSetId The ID of the Data Set
         * @param {'name'} [sortBy] name sorts by the name of the asset
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {boolean} [showActive] Flags whether to include non-deleted (i.e. active) items in the response
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataSetAssets: function (dataSetId, sortBy, order, pageLimit, after, before, showActive, showDeleted, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDataSetAssets(dataSetId, sortBy, order, pageLimit, after, before, showActive, showDeleted, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns a single data set and a summary of if the data set structure is a valid representation of the template. The \"valid\" key returns a boolean indicating if the data set is in a valid state. The \"details\" key indicates where errors have occurred - \"incorrect_asset_count\" returns a list of placeholders with an incorrect number of assets assigned to the placeholder or placeholder and parent asset, \"missing_parameters\" returns a list of parameter types that are missing from a specified assets.
         * @summary Get a data set and its valid status
         * @param {object} dataSetId The ID of the Data Set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataSetValid: function (dataSetId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDataSetValid(dataSetId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all data sets contained within the database
         * @summary Get all data sets
         * @param {Array<string>} [templateId] List of template_ids to search by
         * @param {Array<string>} [projectId] List of project_ids to search by
         * @param {'name' | 'created_at'} [sortBy] name sorts by the name of the data set, created_at sorts by creation date of the data set
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {boolean} [showActive] Flags whether to include non-deleted (i.e. active) items in the response
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataSets: function (templateId, projectId, sortBy, order, pageLimit, after, before, showActive, showDeleted, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDataSets(templateId, projectId, sortBy, order, pageLimit, after, before, showActive, showDeleted, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Gets all entries, queryable by parameter id
         * @summary Get all entries
         * @param {Array<string>} [parameterId] Query by an array of parameter_id\&#39;s
         * @param {Array<string>} [assetId] List of asset_id\&#39;s to search by
         * @param {Array<string>} [projectId] List of project_ids to search by
         * @param {'created_at' | 'updated_at'} [sortBy] created_at sorts by creation date of the entry, updated_at sorts by latest updated date of the entry
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntries: function (parameterId, assetId, projectId, sortBy, order, pageLimit, after, before, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getEntries(parameterId, assetId, projectId, sortBy, order, pageLimit, after, before, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Gets all revisions of an entry, arranged from newest to oldest
         * @summary Get all revisions associated with the specified entry_id
         * @param {object} entryId the id of the entry to search
         * @param {'created_at' | 'updated_at'} [sortBy] created_at sorts by creation date of the entry revision, updated_at sorts by latest updated date of the entry revision
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntryRevisions: function (entryId, sortBy, order, pageLimit, after, before, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getEntryRevisions(entryId, sortBy, order, pageLimit, after, before, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * An endpoint for the permissions service OPA data load.
         * @summary Get asset data for the permissions service OPA load  (Application Admin only).
         * @param {Array<string>} [assetId] List of asset ids to search by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpaLoadAssets: function (assetId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getOpaLoadAssets(assetId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * An endpoint for the permissions service OPA data load.
         * @summary Get data sets data for the permissions service OPA load  (Application Admin only).
         * @param {Array<string>} [dataSetId] List of data_set ids to search by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpaLoadDataSets: function (dataSetId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getOpaLoadDataSets(dataSetId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * An endpoint for the permissions service OPA data load.
         * @summary Get parameter data for the permissions service OPA load  (Application Admin only).
         * @param {Array<string>} [parameterId] List of parameter ids to search by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpaLoadParameters: function (parameterId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getOpaLoadParameters(parameterId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * An endpoint for the permissions service OPA data load.
         * @summary Get revisions data for the permissions service OPA load  (Application Admin only).
         * @param {Array<string>} [revisionId] List of revision ids to search by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpaLoadRevisions: function (revisionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getOpaLoadRevisions(revisionId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Lists all options for an item type
         * @summary Get all options for an item type
         * @param {object} itemTypeId Id of item_type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOptions: function (itemTypeId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getOptions(itemTypeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns parameter by ID from the database.
         * @summary Finds parameter by ID
         * @param {object} parameterId The ID of the parameter to remove
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParameter: function (parameterId, showDeleted, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getParameter(parameterId, showDeleted, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all parameter type by ID from the database
         * @summary Finds all parameter_type by ID - Route moved to Taxonomy Service
         * @param {object} parameterTypeId The ID of the parameter type to search
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getParameterType: function (parameterTypeId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getParameterType(parameterTypeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns metadata for parameter statistics
         * @summary Parameter metadata for count and qa stats
         * @param {Array<string>} [assetId] Asset ID(s) to filter by
         * @param {Array<string>} [assetType] Filters the parameters to those associated with the provided asset_type_ids
         * @param {Array<string>} [parameterTypeId] Filters the parameters to those associated with the provided parameter type ids
         * @param {Array<string>} [projectId] List of project_ids to search by
         * @param {boolean} [projectParameter] Filters parameters to only those without a parent asset
         * @param {Array<string>} [categoryId] Filters the parameters to those associated with the provided category ids
         * @param {Array<string>} [reportId] Filters the parameters to those associated with the provided report ids
         * @param {Array<string>} [disciplineId] Filters the parameters to those associated with the provided discipline ids
         * @param {Array<string>} [parameterSetId] Filters the parameters to those associated with the provided parameter set ids
         * @param {Array<string>} [sourceId] Filters the parameters to those associated with the provided source ids
         * @param {Array<string>} [sourceTypeId] Filters the parameters to those associated with the provided source type ids
         * @param {Array<'unanswered' | 'answered' | 'checked' | 'approved' | 'rejected'>} [qaStatus] Filters the parameters to those with the provided QA status
         * @param {Array<string>} [unitId] Filters the parameters to those associated with the provided unit ids
         * @param {boolean} [showActive] Flags whether to include non-deleted (i.e. active) items in the response
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParametersStatistics: function (assetId, assetType, parameterTypeId, projectId, projectParameter, categoryId, reportId, disciplineId, parameterSetId, sourceId, sourceTypeId, qaStatus, unitId, showActive, showDeleted, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getParametersStatistics(assetId, assetType, parameterTypeId, projectId, projectParameter, categoryId, reportId, disciplineId, parameterSetId, sourceId, sourceTypeId, qaStatus, unitId, showActive, showDeleted, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get Report for given parameter_id and tag_id
         * @summary Get Report for given parameter_id and tag_id
         * @param {object} parameterId The ID of the parameter to remove
         * @param {object} tagId the id of the tag to search
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getReport: function (parameterId, tagId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getReport(parameterId, tagId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns all units relating to the specified unit_type_id within the database. Units are grouped by their unit system.
         * @summary Finds a unit type\'s corresponding units - Route moved to Taxonomy Service
         * @param {object} unitTypeId Unique ID for a single unit type
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getUnitType: function (unitTypeId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getUnitType(unitTypeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update an asset. This endpoint can be used to update an asset name, or restore a  previously deleted asset. Note - name updates on assets that are asset sub type  instances is not allowed. Note -  you cannot restore an asset and update its name  simultaneously, to do this please send separate requests.
         * @summary Patch an existing asset
         * @param {object} assetId Asset ID to retrieve a single asset
         * @param {PatchAssetBody} patchAssetBody Asset name to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAsset: function (assetId, patchAssetBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchAsset(assetId, patchAssetBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update an existing asset type. Note - requires Admin privileges.
         * @summary Patch an existing asset type (Application Admin only) - Route moved to Taxonomy Service
         * @param {object} assetTypeId The ID of the asset type to search
         * @param {PatchAssetTypeBody} patchAssetTypeBody Updates for the asset type
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        patchAssetType: function (assetTypeId, patchAssetTypeBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchAssetType(assetTypeId, patchAssetTypeBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update a data set. This endpoint can be used to update a data set name
         * @summary Patch an existing data set name
         * @param {object} dataSetId The ID of the Data Set
         * @param {PatchDataSetBody} patchDataSetBody Data set name to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDataSet: function (dataSetId, patchDataSetBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchDataSet(dataSetId, patchDataSetBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update an existing parameter type. Note - updating global parameter types (scope = null) requires Admin privileges.
         * @summary Patch existing parameter type - Route moved to Taxonomy Service
         * @param {object} parameterTypeId The ID of the parameter type to search
         * @param {PatchParameterTypeBody} patchParameterTypeBody Updates for parameter type. Note - updating the default unit  will also update the associated unit type
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        patchParameterType: function (parameterTypeId, patchParameterTypeBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchParameterType(parameterTypeId, patchParameterTypeBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Updates the status of the latest entry revisions
         * @summary Update entry revisions
         * @param {PatchRevisionBody} patchRevisionBody Updates to be applied to the latest entry revisions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchRevisions: function (patchRevisionBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchRevisions(patchRevisionBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates a new asset based on the input parameters
         * @summary Create a new asset
         * @param {PostAssetBody} postAssetBody Assets to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAsset: function (postAssetBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postAsset(postAssetBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates new asset sub types. Note - requires Admin privileges.
         * @summary Creates new asset sub types (Application Admin only) - Route moved to Taxonomy Service
         * @param {object} assetTypeId Asset_type_ids to search by
         * @param {PostAssetSubTypesBody} postAssetSubTypesBody New asset sub type details
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        postAssetSubTypes: function (assetTypeId, postAssetSubTypesBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postAssetSubTypes(assetTypeId, postAssetSubTypesBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates an asset type group. Note - requires Admin privileges.
         * @summary Create a new asset type group (Application Admin only) - Route moved to Taxonomy Service
         * @param {PostAssetTypeGroupsBody} postAssetTypeGroupsBody New asset type details
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        postAssetTypeGroups: function (postAssetTypeGroupsBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postAssetTypeGroups(postAssetTypeGroupsBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates an asset type. Note - requires Admin privileges.
         * @summary Create a new asset type (Application Admin only) - Route moved to Taxonomy Service
         * @param {PostAssetTypesBody} postAssetTypesBody New asset type details
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        postAssetTypes: function (postAssetTypesBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postAssetTypes(postAssetTypesBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates a new parameter tag link for a calculation
         * @summary Create a new calculation link
         * @param {object} parameterId The ID of the parameter to remove
         * @param {PostCalculationLinkBody} postCalculationLinkBody Provides the tag_id of the calculation to be linked
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCalculationLink: function (parameterId, postCalculationLinkBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postCalculationLink(parameterId, postCalculationLinkBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates a new parameter tag link for a category
         * @summary Create a new category link
         * @param {object} parameterId The ID of the parameter to remove
         * @param {PostCategoryLinkBody} postCategoryLinkBody Provides the tag_id of the category to be linked
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCategoryLink: function (parameterId, postCategoryLinkBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postCategoryLink(parameterId, postCategoryLinkBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates a new data set based on the specified template. This endpoint creates the dataset and associates all the assets provided in the request body with it. The assets provided must be compliant with the asset_placeholders defined by the template. Any missing parameters from the assets, based on the parameter_placeholders defined in the template, are created automatically as part of this request.
         * @summary Create a new data set
         * @param {PutDataSetBody} putDataSetBody Data sets to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDataSet: function (putDataSetBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postDataSet(putDataSetBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Adds existing assets to an existing data set. This also creates new parameters and links existing parameters associated with the new data set assets.
         * @summary Adds assets to an existing data set.
         * @param {object} dataSetId The ID of the Data Set
         * @param {PostDataSetAssetBody} postDataSetAssetBody Assets to be added to the Data Set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDataSetAssets: function (dataSetId, postDataSetAssetBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postDataSetAssets(dataSetId, postDataSetAssetBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates an item type.  Note - creating a global item type requires Admin privileges.
         * @summary Create a new item type
         * @param {PostItemTypesBody} postItemTypesBody New item type details. You must specify the asset_type_id if posting  with an asset_sub_type_id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postItemTypes: function (postItemTypesBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postItemTypes(postItemTypesBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates new parameter link for a disciplines
         * @summary Create new discipline links
         * @param {object} parameterId The ID of the parameter to remove
         * @param {PostParameterDisciplinesBody} postParameterDisciplinesBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postParameterDisciplines: function (parameterId, postParameterDisciplinesBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postParameterDisciplines(parameterId, postParameterDisciplinesBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates new parameter types. Note - creating global parameter types (scope = null) requires Admin privileges.
         * @summary Creates new parameter types - Route moved to Taxonomy Service
         * @param {PostParameterTypesBody} postParameterTypesBody New parameter type details
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        postParameterTypes: function (postParameterTypesBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postParameterTypes(postParameterTypesBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates a list of new parameters
         * @summary Create a list of new parameters
         * @param {PostParametersBody} postParametersBody parameter to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postParameters: function (postParametersBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postParameters(postParametersBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Creates a new parameter tag link for a report
         * @summary Create a new report link
         * @param {object} parameterId The ID of the parameter to remove
         * @param {PostReportLinkBody} postReportLinkBody Requires the tag_id used to link the new report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postReportLink: function (parameterId, postReportLinkBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postReportLink(parameterId, postReportLinkBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Posts new unit types. This can only be done by an administrator
         * @summary Create new units types. Note - requires Admin privileges. Route moved to Taxonomy Service
         * @param {PostUnitTypesBody} postUnitTypesBody Unit types to be added
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        postUnitTypes: function (postUnitTypesBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postUnitTypes(postUnitTypesBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Posts new units. This can only be done by an administrator
         * @summary Create new units. Note - requires Admin privileges. Route moved to Taxonomy Service
         * @param {PostUnitsBody} postUnitsBody Units to be added
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        postUnits: function (postUnitsBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postUnits(postUnitsBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create or update one or more entries
         * @summary Create or update one or more entries
         * @param {PutEntriesBody} putEntriesBody parameter and entry details to be linked
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putEntries: function (putEntriesBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.putEntries(putEntriesBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Overwrites options for a given item_type by deleting the existing and adding new
         * @summary Sets options for given item_type - Note - creating options for a global item type requires Admin privileges.
         * @param {object} itemTypeId Id of item_type
         * @param {PutOptionsRequest} putOptionsRequest List of values (each value is an object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putOptions: function (itemTypeId, putOptionsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.putOptions(itemTypeId, putOptionsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ParameterApiFp = ParameterApiFp;
/**
 * ParameterApi - factory interface
 * @export
 */
var ParameterApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ParameterApiFp)(configuration);
    return {
        /**
         * Delete an asset. Assets may be restored through the PATCH endpoint.
         * @summary Soft delete an existing asset
         * @param {object} assetId Asset ID to retrieve a single asset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAsset: function (assetId, options) {
            return localVarFp.deleteAsset(assetId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete calculation link for given parameter_id and tag_id
         * @summary Delete calculation link
         * @param {object} parameterId The ID of the parameter to remove
         * @param {object} tagId the id of the tag to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCalculationLink: function (parameterId, tagId, options) {
            return localVarFp.deleteCalculationLink(parameterId, tagId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete category link for given parameter_id and tag_id
         * @summary Delete category link
         * @param {object} parameterId The ID of the parameter to remove
         * @param {object} tagId the id of the tag to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCategoryLink: function (parameterId, tagId, options) {
            return localVarFp.deleteCategoryLink(parameterId, tagId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a data set. Data sets may be restored through the PATCH endpoint.
         * @summary Soft delete an existing data set
         * @param {object} dataSetId The ID of the Data Set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDataSet: function (dataSetId, options) {
            return localVarFp.deleteDataSet(dataSetId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete assets from to an existing data set.
         * @summary Delete assets from an existing data set.
         * @param {object} dataSetId The ID of the Data Set
         * @param {Array<string>} assetId List of Asset IDs to remove from the data set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDataSetAssets: function (dataSetId, assetId, options) {
            return localVarFp.deleteDataSetAssets(dataSetId, assetId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete an item type from the database by id. Note - deleting a global item type requires Admin privileges.
         * @summary Soft delete item type by id
         * @param {object} itemTypeId the id of the item type to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemType: function (itemTypeId, options) {
            return localVarFp.deleteItemType(itemTypeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Soft-deletes options of the given item_type
         * @summary Deletes options for given item_type - Note - deleting options for a global item type requires Admin privileges.
         * @param {object} itemTypeId Id of item_type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOptions: function (itemTypeId, options) {
            return localVarFp.deleteOptions(itemTypeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Marks the parameter with the current datetime as \"deleted_at\" allowing for later restore.
         * @summary Soft delete parameter by ID
         * @param {object} parameterId The ID of the parameter to remove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteParameter: function (parameterId, options) {
            return localVarFp.deleteParameter(parameterId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete link for given parameter_id and discipline_id
         * @summary Delete link for given parameter_id and discipline_id
         * @param {object} parameterId The ID of the parameter to remove
         * @param {object} tagId the id of the tag to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteParameterDiscipline: function (parameterId, tagId, options) {
            return localVarFp.deleteParameterDiscipline(parameterId, tagId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete report link for given parameter_id and tag_id
         * @summary Delete report link
         * @param {object} parameterId The ID of the parameter to remove
         * @param {object} tagId the id of the tag to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReportLink: function (parameterId, tagId, options) {
            return localVarFp.deleteReportLink(parameterId, tagId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all asset type groups contained within the database
         * @summary Finds all asset_type_groups within the database - Route moved to Taxonomy Service
         * @param {Array<string>} [assetTypeGroupId] List of asset_type_group_ids to search by
         * @param {'name'} [sortBy] Field by which to sort projects by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAllAssetTypeGroups: function (assetTypeGroupId, sortBy, order, pageLimit, after, before, options) {
            return localVarFp.getAllAssetTypeGroups(assetTypeGroupId, sortBy, order, pageLimit, after, before, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all asset types contained within the database
         * @summary Finds all asset_types within the database - Route moved to Taxonomy Service
         * @param {Array<string>} [projectId] List of project_ids to search by
         * @param {Array<string>} [assetTypeId] List of asset_type_ids to search by
         * @param {Array<string>} [parentAssetId] List of parent_asset_ids to search by
         * @param {Array<string>} [assetTypeGroupId] List of asset_type_group_ids to search by
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort projects by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {string} [search] search for a source within the database
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAllAssetTypes: function (projectId, assetTypeId, parentAssetId, assetTypeGroupId, sortBy, order, pageLimit, after, before, search, options) {
            return localVarFp.getAllAssetTypes(projectId, assetTypeId, parentAssetId, assetTypeGroupId, sortBy, order, pageLimit, after, before, search, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all calculations for the current parameter
         * @summary Get all calculations
         * @param {object} parameterId The ID of the parameter to remove
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAllCalculations: function (parameterId, options) {
            return localVarFp.getAllCalculations(parameterId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all categories for the current parameter
         * @summary Get all categories
         * @param {object} parameterId The ID of the parameter to remove
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAllCategories: function (parameterId, options) {
            return localVarFp.getAllCategories(parameterId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all item types
         * @summary Get all item types
         * @param {Array<string>} [itemTypeId] List of item_types_id to search by
         * @param {object} [parameterTypeId] parameter_type_id to search by
         * @param {object} [assetTypeId] asset_type_id to search by
         * @param {object} [notAssetTypeId] asset_type_id to exclude
         * @param {object} [assetSubTypeId] asset_sub_type_id to search by
         * @param {object} [notAssetSubTypeId] asset_sub_type_id to exclude
         * @param {boolean} [showGlobal] Flags whether to include global item_types in the response.
         * @param {boolean} [showLocal] Flags whether to include non-global item_types that are scoped to a project.
         * @param {string} [scopeId] The ID of the project to filter non-global item_types by. The response will include non-global item_types that are scoped to the project specified in the query. show_local must be set to true to show results of this query.
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {'created_at' | 'parameter_type_name'} [sortBy] created_at sorts by creation date of the parameter and parameter_type_name sorts by the name of the revisions parameter_type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllItemTypes: function (itemTypeId, parameterTypeId, assetTypeId, notAssetTypeId, assetSubTypeId, notAssetSubTypeId, showGlobal, showLocal, scopeId, order, pageLimit, after, before, sortBy, options) {
            return localVarFp.getAllItemTypes(itemTypeId, parameterTypeId, assetTypeId, notAssetTypeId, assetSubTypeId, notAssetSubTypeId, showGlobal, showLocal, scopeId, order, pageLimit, after, before, sortBy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all disciplines for the current parameter
         * @summary Get all disciplines
         * @param {object} parameterId The ID of the parameter to remove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllParameterDisciplines: function (parameterId, options) {
            return localVarFp.getAllParameterDisciplines(parameterId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all parameter types contained within the database
         * @summary Finds all parameter_types within the database - Route moved to Taxonomy Service
         * @param {object} [notAssetId] The ID of the asset to filter parameter_types by , will only return parameter_types that are not attached to the given asset_id
         * @param {object} [projectId] The ID of the project to filter parameter_types by, will only return parameter_types that have an existing parameter instance on the given project_id
         * @param {object} [notProjectId] The ID of the project to filter parameter_types by , will only return parameter_types that do not have an existing parameter instance on the given project_id
         * @param {object} [assetTypeId] The ID of the asset type to filter parameter_types by , will only return parameter_types that are attached to the given asset_type. An empty asset_type_id query will return parameter_types that have no asset_type associated with them (i.e. project level parameters)
         * @param {object} [assetSubTypeId] The ID of the asset sub type to filter parameter_types by , will only return parameter_types that are attached to the given asset_sub_type. An empty asset_sub_type_id query will return parameter_types that have no asset_sub_type associated with them (i.e. of asset type with no sub types or project level parameters)
         * @param {Array<string>} [parameterTypeId] Query by an array of parameter_type_id\&#39;s
         * @param {boolean} [showGlobal] Flags whether to include global parameter types in the response.
         * @param {boolean} [showLocal] Flags whether to include non-global parameter_types that are scoped to a project.
         * @param {string} [scopeId] The ID of the project to filter non-global parameter_types by. The response will include non-global parameter_types that are scoped to the project specified in the query. show_local must be set to true to show results of this query.
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort projects by
         * @param {Array<string>} [assetId] Asset ID(s) to filter by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {string} [search] search for a source within the database
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAllParameterTypes: function (notAssetId, projectId, notProjectId, assetTypeId, assetSubTypeId, parameterTypeId, showGlobal, showLocal, scopeId, sortBy, assetId, order, pageLimit, after, before, search, options) {
            return localVarFp.getAllParameterTypes(notAssetId, projectId, notProjectId, assetTypeId, assetSubTypeId, parameterTypeId, showGlobal, showLocal, scopeId, sortBy, assetId, order, pageLimit, after, before, search, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all parameters contained within the database. Queries are in the format `?query_name=[\"uuid1\", \"uuid2\"], where the array is in valid json format.
         * @summary Finds all parameters within the database
         * @param {Array<string>} [assetId] Asset ID(s) to filter by
         * @param {Array<string>} [assetType] Filters the parameters to those associated with the provided asset_type_ids
         * @param {Array<string>} [parameterId] Filters the parameters by the provided parameter ids
         * @param {Array<string>} [parameterTypeId] Filters the parameters to those associated with the provided parameter type ids
         * @param {Array<string>} [projectId] List of project_ids to search by
         * @param {boolean} [projectParameter] Filters parameters to only those without a parent asset
         * @param {Array<string>} [categoryId] Filters the parameters to those associated with the provided category ids
         * @param {Array<string>} [reportId] Filters the parameters to those associated with the provided report ids
         * @param {Array<string>} [disciplineId] Filters the parameters to those associated with the provided discipline ids
         * @param {Array<string>} [dataSetId] Filters parameters by the provided data_set_ids
         * @param {Array<string>} [parameterSetId] Filters parameters by the provided parameter_set_ids
         * @param {Array<string>} [sourceId] Filters the parameters to those associated with the provided source ids
         * @param {Array<string>} [sourceTypeId] Filters the parameters to those associated with the provided source type ids
         * @param {Array<'unanswered' | 'answered' | 'checked' | 'approved' | 'rejected'>} [qaStatus] Filters the parameters to those with the provided QA status
         * @param {Array<string>} [unitId] Filters the parameters to those associated with the provided unit ids
         * @param {Array<string>} [itemTypeId] Filters parameters by the provided item_type_ids
         * @param {'created_at' | 'revised_at' | 'parameter_type_name' | 'qa_status'} [sortBy] created_at sorts by creation date of the parameter, revised_at sorts by creation date of the revision, qa_status sorts by the parameter status, value sorts by the current value of the parameter, units sorts by the unit of the parameter and parameter_type_name sorts by the name of the revisions parameter_type
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {boolean} [showActive] Flags whether to include non-deleted (i.e. active) items in the response
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllParameters: function (assetId, assetType, parameterId, parameterTypeId, projectId, projectParameter, categoryId, reportId, disciplineId, dataSetId, parameterSetId, sourceId, sourceTypeId, qaStatus, unitId, itemTypeId, sortBy, order, pageLimit, after, before, showActive, showDeleted, options) {
            return localVarFp.getAllParameters(assetId, assetType, parameterId, parameterTypeId, projectId, projectParameter, categoryId, reportId, disciplineId, dataSetId, parameterSetId, sourceId, sourceTypeId, qaStatus, unitId, itemTypeId, sortBy, order, pageLimit, after, before, showActive, showDeleted, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all reports for the current parameter
         * @summary Get all reports
         * @param {object} parameterId The ID of the parameter to remove
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAllReports: function (parameterId, options) {
            return localVarFp.getAllReports(parameterId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all units systems contained within the database. Unit systems are unique by name.
         * @summary Finds all unit systems within the database - Route moved to Taxonomy Service
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort projects by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAllUnitSystems: function (sortBy, order, pageLimit, after, before, options) {
            return localVarFp.getAllUnitSystems(sortBy, order, pageLimit, after, before, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all units types contained within the database. Unit types are unique by name. Note - the available unit types for a parameter type should be obtained from the parameter_types endpoint.
         * @summary Finds all unit types within the database - Route moved to Taxonomy Service
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort projects by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {Array<string>} [unitTypeId] Filters the unit types to those associated with the provided unit type ids
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAllUnitTypes: function (sortBy, order, pageLimit, after, before, unitTypeId, options) {
            return localVarFp.getAllUnitTypes(sortBy, order, pageLimit, after, before, unitTypeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all units contained within the database. Units are unique by name. Note - the available units for a parameter type should be obtained from the parameter_types endpoint.
         * @summary Finds all units within the database - Route moved to Taxonomy Service
         * @param {Array<string>} [parameterTypeId] Filters the parameters to those associated with the provided parameter type ids
         * @param {'created_at' | 'symbol'} [sortBy] Field by which to sort projects by
         * @param {Array<string>} [assetId] Asset ID(s) to filter by
         * @param {Array<string>} [projectId] List of project_ids to search by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAllUnits: function (parameterTypeId, sortBy, assetId, projectId, order, pageLimit, after, before, options) {
            return localVarFp.getAllUnits(parameterTypeId, sortBy, assetId, projectId, order, pageLimit, after, before, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns asset by ID contained within the database
         * @summary Finds an asset within the database
         * @param {object} assetId Asset ID to retrieve a single asset
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAsset: function (assetId, showDeleted, options) {
            return localVarFp.getAsset(assetId, showDeleted, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns the ordered hierarchies of a given asset and its parents [great-grandparent, grandparent, parent, itself]
         * @summary Returns the ordered hierarchies of a given asset and its parents
         * @param {Array<string>} assetIds Asset IDs to retrieve the hierarchy of
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetHierarchy: function (assetIds, showDeleted, options) {
            return localVarFp.getAssetHierarchy(assetIds, showDeleted, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all asset sub types related to the specified asset type contained within the database
         * @summary Finds all asset_sub_types related to the asset_type_id - Route moved to Taxonomy Service
         * @param {object} assetTypeId Asset_type_id to search by
         * @param {Array<string>} [assetSubTypeId] The asset_sub_type_id to search by
         * @param {object} [parentAssetSubTypeId] Unique ID of the asset sub type\&#39;s parent asset sub type (for example the variable temperature sub-system would have a parent of the hot water system)
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort asset_sub_types by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {string} [search] search for a source within the database
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAssetSubTypes: function (assetTypeId, assetSubTypeId, parentAssetSubTypeId, sortBy, order, pageLimit, after, before, search, options) {
            return localVarFp.getAssetSubTypes(assetTypeId, assetSubTypeId, parentAssetSubTypeId, sortBy, order, pageLimit, after, before, search, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all id, name, asset_type_id, and parent_asset_sub_type_id of  asset sub types related to the specified asset sub type ids contained within the database
         * @summary Finds all asset_sub_types associated with provided asset_sub_type_id - Route moved to Taxonomy Service
         * @param {Array<string>} [assetSubTypeId] The asset_sub_type_ids to search by
         * @param {'created_at' | 'name'} [sortBy] Field by which to sort asset_sub_types by
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {string} [search] search for a source within the database
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAssetSubTypesRef: function (assetSubTypeId, sortBy, order, pageLimit, after, before, search, options) {
            return localVarFp.getAssetSubTypesRef(assetSubTypeId, sortBy, order, pageLimit, after, before, search, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all asset types contained within the database
         * @summary Gets an asset tree by asset_id within the database
         * @param {string} assetId asset_id to query by
         * @param {number} [depth] This is depth level at which the asset tree children are returned. Depth 1 would return the children of the asset queried. Depth 2 will include the children of the assets returned for depth 1. If depth is empty the full asset tree is returned.
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetTree: function (assetId, depth, showDeleted, options) {
            return localVarFp.getAssetTree(assetId, depth, showDeleted, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns parent, children, grandchildren etc. asset types contained within the database
         * @summary Gets an asset type tree by asset_type_id within the database - Route moved to Taxonomy Service
         * @param {Array<string>} assetTypeId List of asset_type_ids to query by
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAssetTypeTree: function (assetTypeId, options) {
            return localVarFp.getAssetTypeTree(assetTypeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all assets contained within the database
         * @summary Finds all assets within the database
         * @param {Array<string>} [assetId] List of asset_id\&#39;s to search by
         * @param {Array<string>} [assetTypeId] List of asset_type_id\&#39;s to search by
         * @param {Array<string>} [parentId] List of parent asset_id\&#39;s, filtering the assets to only the children of the assets provided
         * @param {Array<string>} [descendantsOf] Single asset_id, to filter the assets to only the children of the asset provided and their children.
         * @param {Array<string>} [projectId] List of project_ids to search by
         * @param {boolean} [showActive] Flags whether to include non-deleted (i.e. active) items in the response
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {'name'} [sortBy] name sorts by the name of the asset
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssets: function (assetId, assetTypeId, parentId, descendantsOf, projectId, showActive, showDeleted, sortBy, order, pageLimit, after, before, options) {
            return localVarFp.getAssets(assetId, assetTypeId, parentId, descendantsOf, projectId, showActive, showDeleted, sortBy, order, pageLimit, after, before, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get Calculation for given parameter_id and tag_id
         * @summary Get Calculation for given parameter_id and tag_id
         * @param {object} parameterId The ID of the parameter to remove
         * @param {object} tagId the id of the tag to search
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getCalculation: function (parameterId, tagId, options) {
            return localVarFp.getCalculation(parameterId, tagId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get Category for given parameter_id and tag_id
         * @summary Get Category for given parameter_id and tag_id
         * @param {object} parameterId The ID of the parameter to remove
         * @param {object} tagId the id of the tag to search
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getCategory: function (parameterId, tagId, options) {
            return localVarFp.getCategory(parameterId, tagId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all assets contained within a single data set
         * @summary Get all assets contained within a dataset
         * @param {object} dataSetId The ID of the Data Set
         * @param {'name'} [sortBy] name sorts by the name of the asset
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {boolean} [showActive] Flags whether to include non-deleted (i.e. active) items in the response
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataSetAssets: function (dataSetId, sortBy, order, pageLimit, after, before, showActive, showDeleted, options) {
            return localVarFp.getDataSetAssets(dataSetId, sortBy, order, pageLimit, after, before, showActive, showDeleted, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a single data set and a summary of if the data set structure is a valid representation of the template. The \"valid\" key returns a boolean indicating if the data set is in a valid state. The \"details\" key indicates where errors have occurred - \"incorrect_asset_count\" returns a list of placeholders with an incorrect number of assets assigned to the placeholder or placeholder and parent asset, \"missing_parameters\" returns a list of parameter types that are missing from a specified assets.
         * @summary Get a data set and its valid status
         * @param {object} dataSetId The ID of the Data Set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataSetValid: function (dataSetId, options) {
            return localVarFp.getDataSetValid(dataSetId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all data sets contained within the database
         * @summary Get all data sets
         * @param {Array<string>} [templateId] List of template_ids to search by
         * @param {Array<string>} [projectId] List of project_ids to search by
         * @param {'name' | 'created_at'} [sortBy] name sorts by the name of the data set, created_at sorts by creation date of the data set
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {boolean} [showActive] Flags whether to include non-deleted (i.e. active) items in the response
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataSets: function (templateId, projectId, sortBy, order, pageLimit, after, before, showActive, showDeleted, options) {
            return localVarFp.getDataSets(templateId, projectId, sortBy, order, pageLimit, after, before, showActive, showDeleted, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Gets all entries, queryable by parameter id
         * @summary Get all entries
         * @param {Array<string>} [parameterId] Query by an array of parameter_id\&#39;s
         * @param {Array<string>} [assetId] List of asset_id\&#39;s to search by
         * @param {Array<string>} [projectId] List of project_ids to search by
         * @param {'created_at' | 'updated_at'} [sortBy] created_at sorts by creation date of the entry, updated_at sorts by latest updated date of the entry
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntries: function (parameterId, assetId, projectId, sortBy, order, pageLimit, after, before, options) {
            return localVarFp.getEntries(parameterId, assetId, projectId, sortBy, order, pageLimit, after, before, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Gets all revisions of an entry, arranged from newest to oldest
         * @summary Get all revisions associated with the specified entry_id
         * @param {object} entryId the id of the entry to search
         * @param {'created_at' | 'updated_at'} [sortBy] created_at sorts by creation date of the entry revision, updated_at sorts by latest updated date of the entry revision
         * @param {'asc' | 'desc'} [order] sort order direction
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntryRevisions: function (entryId, sortBy, order, pageLimit, after, before, options) {
            return localVarFp.getEntryRevisions(entryId, sortBy, order, pageLimit, after, before, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * An endpoint for the permissions service OPA data load.
         * @summary Get asset data for the permissions service OPA load  (Application Admin only).
         * @param {Array<string>} [assetId] List of asset ids to search by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpaLoadAssets: function (assetId, options) {
            return localVarFp.getOpaLoadAssets(assetId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * An endpoint for the permissions service OPA data load.
         * @summary Get data sets data for the permissions service OPA load  (Application Admin only).
         * @param {Array<string>} [dataSetId] List of data_set ids to search by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpaLoadDataSets: function (dataSetId, options) {
            return localVarFp.getOpaLoadDataSets(dataSetId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * An endpoint for the permissions service OPA data load.
         * @summary Get parameter data for the permissions service OPA load  (Application Admin only).
         * @param {Array<string>} [parameterId] List of parameter ids to search by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpaLoadParameters: function (parameterId, options) {
            return localVarFp.getOpaLoadParameters(parameterId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * An endpoint for the permissions service OPA data load.
         * @summary Get revisions data for the permissions service OPA load  (Application Admin only).
         * @param {Array<string>} [revisionId] List of revision ids to search by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpaLoadRevisions: function (revisionId, options) {
            return localVarFp.getOpaLoadRevisions(revisionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Lists all options for an item type
         * @summary Get all options for an item type
         * @param {object} itemTypeId Id of item_type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOptions: function (itemTypeId, options) {
            return localVarFp.getOptions(itemTypeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns parameter by ID from the database.
         * @summary Finds parameter by ID
         * @param {object} parameterId The ID of the parameter to remove
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParameter: function (parameterId, showDeleted, options) {
            return localVarFp.getParameter(parameterId, showDeleted, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all parameter type by ID from the database
         * @summary Finds all parameter_type by ID - Route moved to Taxonomy Service
         * @param {object} parameterTypeId The ID of the parameter type to search
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getParameterType: function (parameterTypeId, options) {
            return localVarFp.getParameterType(parameterTypeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns metadata for parameter statistics
         * @summary Parameter metadata for count and qa stats
         * @param {Array<string>} [assetId] Asset ID(s) to filter by
         * @param {Array<string>} [assetType] Filters the parameters to those associated with the provided asset_type_ids
         * @param {Array<string>} [parameterTypeId] Filters the parameters to those associated with the provided parameter type ids
         * @param {Array<string>} [projectId] List of project_ids to search by
         * @param {boolean} [projectParameter] Filters parameters to only those without a parent asset
         * @param {Array<string>} [categoryId] Filters the parameters to those associated with the provided category ids
         * @param {Array<string>} [reportId] Filters the parameters to those associated with the provided report ids
         * @param {Array<string>} [disciplineId] Filters the parameters to those associated with the provided discipline ids
         * @param {Array<string>} [parameterSetId] Filters the parameters to those associated with the provided parameter set ids
         * @param {Array<string>} [sourceId] Filters the parameters to those associated with the provided source ids
         * @param {Array<string>} [sourceTypeId] Filters the parameters to those associated with the provided source type ids
         * @param {Array<'unanswered' | 'answered' | 'checked' | 'approved' | 'rejected'>} [qaStatus] Filters the parameters to those with the provided QA status
         * @param {Array<string>} [unitId] Filters the parameters to those associated with the provided unit ids
         * @param {boolean} [showActive] Flags whether to include non-deleted (i.e. active) items in the response
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParametersStatistics: function (assetId, assetType, parameterTypeId, projectId, projectParameter, categoryId, reportId, disciplineId, parameterSetId, sourceId, sourceTypeId, qaStatus, unitId, showActive, showDeleted, options) {
            return localVarFp.getParametersStatistics(assetId, assetType, parameterTypeId, projectId, projectParameter, categoryId, reportId, disciplineId, parameterSetId, sourceId, sourceTypeId, qaStatus, unitId, showActive, showDeleted, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get Report for given parameter_id and tag_id
         * @summary Get Report for given parameter_id and tag_id
         * @param {object} parameterId The ID of the parameter to remove
         * @param {object} tagId the id of the tag to search
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getReport: function (parameterId, tagId, options) {
            return localVarFp.getReport(parameterId, tagId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns all units relating to the specified unit_type_id within the database. Units are grouped by their unit system.
         * @summary Finds a unit type\'s corresponding units - Route moved to Taxonomy Service
         * @param {object} unitTypeId Unique ID for a single unit type
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getUnitType: function (unitTypeId, options) {
            return localVarFp.getUnitType(unitTypeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update an asset. This endpoint can be used to update an asset name, or restore a  previously deleted asset. Note - name updates on assets that are asset sub type  instances is not allowed. Note -  you cannot restore an asset and update its name  simultaneously, to do this please send separate requests.
         * @summary Patch an existing asset
         * @param {object} assetId Asset ID to retrieve a single asset
         * @param {PatchAssetBody} patchAssetBody Asset name to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAsset: function (assetId, patchAssetBody, options) {
            return localVarFp.patchAsset(assetId, patchAssetBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update an existing asset type. Note - requires Admin privileges.
         * @summary Patch an existing asset type (Application Admin only) - Route moved to Taxonomy Service
         * @param {object} assetTypeId The ID of the asset type to search
         * @param {PatchAssetTypeBody} patchAssetTypeBody Updates for the asset type
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        patchAssetType: function (assetTypeId, patchAssetTypeBody, options) {
            return localVarFp.patchAssetType(assetTypeId, patchAssetTypeBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update a data set. This endpoint can be used to update a data set name
         * @summary Patch an existing data set name
         * @param {object} dataSetId The ID of the Data Set
         * @param {PatchDataSetBody} patchDataSetBody Data set name to be updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDataSet: function (dataSetId, patchDataSetBody, options) {
            return localVarFp.patchDataSet(dataSetId, patchDataSetBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update an existing parameter type. Note - updating global parameter types (scope = null) requires Admin privileges.
         * @summary Patch existing parameter type - Route moved to Taxonomy Service
         * @param {object} parameterTypeId The ID of the parameter type to search
         * @param {PatchParameterTypeBody} patchParameterTypeBody Updates for parameter type. Note - updating the default unit  will also update the associated unit type
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        patchParameterType: function (parameterTypeId, patchParameterTypeBody, options) {
            return localVarFp.patchParameterType(parameterTypeId, patchParameterTypeBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates the status of the latest entry revisions
         * @summary Update entry revisions
         * @param {PatchRevisionBody} patchRevisionBody Updates to be applied to the latest entry revisions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchRevisions: function (patchRevisionBody, options) {
            return localVarFp.patchRevisions(patchRevisionBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates a new asset based on the input parameters
         * @summary Create a new asset
         * @param {PostAssetBody} postAssetBody Assets to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAsset: function (postAssetBody, options) {
            return localVarFp.postAsset(postAssetBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates new asset sub types. Note - requires Admin privileges.
         * @summary Creates new asset sub types (Application Admin only) - Route moved to Taxonomy Service
         * @param {object} assetTypeId Asset_type_ids to search by
         * @param {PostAssetSubTypesBody} postAssetSubTypesBody New asset sub type details
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        postAssetSubTypes: function (assetTypeId, postAssetSubTypesBody, options) {
            return localVarFp.postAssetSubTypes(assetTypeId, postAssetSubTypesBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates an asset type group. Note - requires Admin privileges.
         * @summary Create a new asset type group (Application Admin only) - Route moved to Taxonomy Service
         * @param {PostAssetTypeGroupsBody} postAssetTypeGroupsBody New asset type details
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        postAssetTypeGroups: function (postAssetTypeGroupsBody, options) {
            return localVarFp.postAssetTypeGroups(postAssetTypeGroupsBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates an asset type. Note - requires Admin privileges.
         * @summary Create a new asset type (Application Admin only) - Route moved to Taxonomy Service
         * @param {PostAssetTypesBody} postAssetTypesBody New asset type details
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        postAssetTypes: function (postAssetTypesBody, options) {
            return localVarFp.postAssetTypes(postAssetTypesBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates a new parameter tag link for a calculation
         * @summary Create a new calculation link
         * @param {object} parameterId The ID of the parameter to remove
         * @param {PostCalculationLinkBody} postCalculationLinkBody Provides the tag_id of the calculation to be linked
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCalculationLink: function (parameterId, postCalculationLinkBody, options) {
            return localVarFp.postCalculationLink(parameterId, postCalculationLinkBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates a new parameter tag link for a category
         * @summary Create a new category link
         * @param {object} parameterId The ID of the parameter to remove
         * @param {PostCategoryLinkBody} postCategoryLinkBody Provides the tag_id of the category to be linked
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCategoryLink: function (parameterId, postCategoryLinkBody, options) {
            return localVarFp.postCategoryLink(parameterId, postCategoryLinkBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates a new data set based on the specified template. This endpoint creates the dataset and associates all the assets provided in the request body with it. The assets provided must be compliant with the asset_placeholders defined by the template. Any missing parameters from the assets, based on the parameter_placeholders defined in the template, are created automatically as part of this request.
         * @summary Create a new data set
         * @param {PutDataSetBody} putDataSetBody Data sets to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDataSet: function (putDataSetBody, options) {
            return localVarFp.postDataSet(putDataSetBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Adds existing assets to an existing data set. This also creates new parameters and links existing parameters associated with the new data set assets.
         * @summary Adds assets to an existing data set.
         * @param {object} dataSetId The ID of the Data Set
         * @param {PostDataSetAssetBody} postDataSetAssetBody Assets to be added to the Data Set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDataSetAssets: function (dataSetId, postDataSetAssetBody, options) {
            return localVarFp.postDataSetAssets(dataSetId, postDataSetAssetBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates an item type.  Note - creating a global item type requires Admin privileges.
         * @summary Create a new item type
         * @param {PostItemTypesBody} postItemTypesBody New item type details. You must specify the asset_type_id if posting  with an asset_sub_type_id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postItemTypes: function (postItemTypesBody, options) {
            return localVarFp.postItemTypes(postItemTypesBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates new parameter link for a disciplines
         * @summary Create new discipline links
         * @param {object} parameterId The ID of the parameter to remove
         * @param {PostParameterDisciplinesBody} postParameterDisciplinesBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postParameterDisciplines: function (parameterId, postParameterDisciplinesBody, options) {
            return localVarFp.postParameterDisciplines(parameterId, postParameterDisciplinesBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates new parameter types. Note - creating global parameter types (scope = null) requires Admin privileges.
         * @summary Creates new parameter types - Route moved to Taxonomy Service
         * @param {PostParameterTypesBody} postParameterTypesBody New parameter type details
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        postParameterTypes: function (postParameterTypesBody, options) {
            return localVarFp.postParameterTypes(postParameterTypesBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates a list of new parameters
         * @summary Create a list of new parameters
         * @param {PostParametersBody} postParametersBody parameter to be added
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postParameters: function (postParametersBody, options) {
            return localVarFp.postParameters(postParametersBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates a new parameter tag link for a report
         * @summary Create a new report link
         * @param {object} parameterId The ID of the parameter to remove
         * @param {PostReportLinkBody} postReportLinkBody Requires the tag_id used to link the new report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postReportLink: function (parameterId, postReportLinkBody, options) {
            return localVarFp.postReportLink(parameterId, postReportLinkBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Posts new unit types. This can only be done by an administrator
         * @summary Create new units types. Note - requires Admin privileges. Route moved to Taxonomy Service
         * @param {PostUnitTypesBody} postUnitTypesBody Unit types to be added
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        postUnitTypes: function (postUnitTypesBody, options) {
            return localVarFp.postUnitTypes(postUnitTypesBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Posts new units. This can only be done by an administrator
         * @summary Create new units. Note - requires Admin privileges. Route moved to Taxonomy Service
         * @param {PostUnitsBody} postUnitsBody Units to be added
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        postUnits: function (postUnitsBody, options) {
            return localVarFp.postUnits(postUnitsBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create or update one or more entries
         * @summary Create or update one or more entries
         * @param {PutEntriesBody} putEntriesBody parameter and entry details to be linked
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putEntries: function (putEntriesBody, options) {
            return localVarFp.putEntries(putEntriesBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Overwrites options for a given item_type by deleting the existing and adding new
         * @summary Sets options for given item_type - Note - creating options for a global item type requires Admin privileges.
         * @param {object} itemTypeId Id of item_type
         * @param {PutOptionsRequest} putOptionsRequest List of values (each value is an object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putOptions: function (itemTypeId, putOptionsRequest, options) {
            return localVarFp.putOptions(itemTypeId, putOptionsRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ParameterApiFactory = ParameterApiFactory;
/**
 * ParameterApi - object-oriented interface
 * @export
 * @class ParameterApi
 * @extends {BaseAPI}
 */
var ParameterApi = /** @class */ (function (_super) {
    __extends(ParameterApi, _super);
    function ParameterApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Delete an asset. Assets may be restored through the PATCH endpoint.
     * @summary Soft delete an existing asset
     * @param {ParameterApiDeleteAssetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.deleteAsset = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).deleteAsset(requestParameters.assetId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete calculation link for given parameter_id and tag_id
     * @summary Delete calculation link
     * @param {ParameterApiDeleteCalculationLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.deleteCalculationLink = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).deleteCalculationLink(requestParameters.parameterId, requestParameters.tagId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete category link for given parameter_id and tag_id
     * @summary Delete category link
     * @param {ParameterApiDeleteCategoryLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.deleteCategoryLink = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).deleteCategoryLink(requestParameters.parameterId, requestParameters.tagId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a data set. Data sets may be restored through the PATCH endpoint.
     * @summary Soft delete an existing data set
     * @param {ParameterApiDeleteDataSetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.deleteDataSet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).deleteDataSet(requestParameters.dataSetId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete assets from to an existing data set.
     * @summary Delete assets from an existing data set.
     * @param {ParameterApiDeleteDataSetAssetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.deleteDataSetAssets = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).deleteDataSetAssets(requestParameters.dataSetId, requestParameters.assetId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete an item type from the database by id. Note - deleting a global item type requires Admin privileges.
     * @summary Soft delete item type by id
     * @param {ParameterApiDeleteItemTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.deleteItemType = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).deleteItemType(requestParameters.itemTypeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Soft-deletes options of the given item_type
     * @summary Deletes options for given item_type - Note - deleting options for a global item type requires Admin privileges.
     * @param {ParameterApiDeleteOptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.deleteOptions = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).deleteOptions(requestParameters.itemTypeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Marks the parameter with the current datetime as \"deleted_at\" allowing for later restore.
     * @summary Soft delete parameter by ID
     * @param {ParameterApiDeleteParameterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.deleteParameter = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).deleteParameter(requestParameters.parameterId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete link for given parameter_id and discipline_id
     * @summary Delete link for given parameter_id and discipline_id
     * @param {ParameterApiDeleteParameterDisciplineRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.deleteParameterDiscipline = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).deleteParameterDiscipline(requestParameters.parameterId, requestParameters.tagId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete report link for given parameter_id and tag_id
     * @summary Delete report link
     * @param {ParameterApiDeleteReportLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.deleteReportLink = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).deleteReportLink(requestParameters.parameterId, requestParameters.tagId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all asset type groups contained within the database
     * @summary Finds all asset_type_groups within the database - Route moved to Taxonomy Service
     * @param {ParameterApiGetAllAssetTypeGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getAllAssetTypeGroups = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ParameterApiFp)(this.configuration).getAllAssetTypeGroups(requestParameters.assetTypeGroupId, requestParameters.sortBy, requestParameters.order, requestParameters.pageLimit, requestParameters.after, requestParameters.before, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all asset types contained within the database
     * @summary Finds all asset_types within the database - Route moved to Taxonomy Service
     * @param {ParameterApiGetAllAssetTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getAllAssetTypes = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ParameterApiFp)(this.configuration).getAllAssetTypes(requestParameters.projectId, requestParameters.assetTypeId, requestParameters.parentAssetId, requestParameters.assetTypeGroupId, requestParameters.sortBy, requestParameters.order, requestParameters.pageLimit, requestParameters.after, requestParameters.before, requestParameters.search, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all calculations for the current parameter
     * @summary Get all calculations
     * @param {ParameterApiGetAllCalculationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getAllCalculations = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).getAllCalculations(requestParameters.parameterId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all categories for the current parameter
     * @summary Get all categories
     * @param {ParameterApiGetAllCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getAllCategories = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).getAllCategories(requestParameters.parameterId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all item types
     * @summary Get all item types
     * @param {ParameterApiGetAllItemTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getAllItemTypes = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ParameterApiFp)(this.configuration).getAllItemTypes(requestParameters.itemTypeId, requestParameters.parameterTypeId, requestParameters.assetTypeId, requestParameters.notAssetTypeId, requestParameters.assetSubTypeId, requestParameters.notAssetSubTypeId, requestParameters.showGlobal, requestParameters.showLocal, requestParameters.scopeId, requestParameters.order, requestParameters.pageLimit, requestParameters.after, requestParameters.before, requestParameters.sortBy, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all disciplines for the current parameter
     * @summary Get all disciplines
     * @param {ParameterApiGetAllParameterDisciplinesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getAllParameterDisciplines = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).getAllParameterDisciplines(requestParameters.parameterId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all parameter types contained within the database
     * @summary Finds all parameter_types within the database - Route moved to Taxonomy Service
     * @param {ParameterApiGetAllParameterTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getAllParameterTypes = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ParameterApiFp)(this.configuration).getAllParameterTypes(requestParameters.notAssetId, requestParameters.projectId, requestParameters.notProjectId, requestParameters.assetTypeId, requestParameters.assetSubTypeId, requestParameters.parameterTypeId, requestParameters.showGlobal, requestParameters.showLocal, requestParameters.scopeId, requestParameters.sortBy, requestParameters.assetId, requestParameters.order, requestParameters.pageLimit, requestParameters.after, requestParameters.before, requestParameters.search, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all parameters contained within the database. Queries are in the format `?query_name=[\"uuid1\", \"uuid2\"], where the array is in valid json format.
     * @summary Finds all parameters within the database
     * @param {ParameterApiGetAllParametersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getAllParameters = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ParameterApiFp)(this.configuration).getAllParameters(requestParameters.assetId, requestParameters.assetType, requestParameters.parameterId, requestParameters.parameterTypeId, requestParameters.projectId, requestParameters.projectParameter, requestParameters.categoryId, requestParameters.reportId, requestParameters.disciplineId, requestParameters.dataSetId, requestParameters.parameterSetId, requestParameters.sourceId, requestParameters.sourceTypeId, requestParameters.qaStatus, requestParameters.unitId, requestParameters.itemTypeId, requestParameters.sortBy, requestParameters.order, requestParameters.pageLimit, requestParameters.after, requestParameters.before, requestParameters.showActive, requestParameters.showDeleted, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all reports for the current parameter
     * @summary Get all reports
     * @param {ParameterApiGetAllReportsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getAllReports = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).getAllReports(requestParameters.parameterId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all units systems contained within the database. Unit systems are unique by name.
     * @summary Finds all unit systems within the database - Route moved to Taxonomy Service
     * @param {ParameterApiGetAllUnitSystemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getAllUnitSystems = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ParameterApiFp)(this.configuration).getAllUnitSystems(requestParameters.sortBy, requestParameters.order, requestParameters.pageLimit, requestParameters.after, requestParameters.before, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all units types contained within the database. Unit types are unique by name. Note - the available unit types for a parameter type should be obtained from the parameter_types endpoint.
     * @summary Finds all unit types within the database - Route moved to Taxonomy Service
     * @param {ParameterApiGetAllUnitTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getAllUnitTypes = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ParameterApiFp)(this.configuration).getAllUnitTypes(requestParameters.sortBy, requestParameters.order, requestParameters.pageLimit, requestParameters.after, requestParameters.before, requestParameters.unitTypeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all units contained within the database. Units are unique by name. Note - the available units for a parameter type should be obtained from the parameter_types endpoint.
     * @summary Finds all units within the database - Route moved to Taxonomy Service
     * @param {ParameterApiGetAllUnitsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getAllUnits = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ParameterApiFp)(this.configuration).getAllUnits(requestParameters.parameterTypeId, requestParameters.sortBy, requestParameters.assetId, requestParameters.projectId, requestParameters.order, requestParameters.pageLimit, requestParameters.after, requestParameters.before, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns asset by ID contained within the database
     * @summary Finds an asset within the database
     * @param {ParameterApiGetAssetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getAsset = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).getAsset(requestParameters.assetId, requestParameters.showDeleted, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns the ordered hierarchies of a given asset and its parents [great-grandparent, grandparent, parent, itself]
     * @summary Returns the ordered hierarchies of a given asset and its parents
     * @param {ParameterApiGetAssetHierarchyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getAssetHierarchy = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).getAssetHierarchy(requestParameters.assetIds, requestParameters.showDeleted, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all asset sub types related to the specified asset type contained within the database
     * @summary Finds all asset_sub_types related to the asset_type_id - Route moved to Taxonomy Service
     * @param {ParameterApiGetAssetSubTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getAssetSubTypes = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).getAssetSubTypes(requestParameters.assetTypeId, requestParameters.assetSubTypeId, requestParameters.parentAssetSubTypeId, requestParameters.sortBy, requestParameters.order, requestParameters.pageLimit, requestParameters.after, requestParameters.before, requestParameters.search, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all id, name, asset_type_id, and parent_asset_sub_type_id of  asset sub types related to the specified asset sub type ids contained within the database
     * @summary Finds all asset_sub_types associated with provided asset_sub_type_id - Route moved to Taxonomy Service
     * @param {ParameterApiGetAssetSubTypesRefRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getAssetSubTypesRef = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ParameterApiFp)(this.configuration).getAssetSubTypesRef(requestParameters.assetSubTypeId, requestParameters.sortBy, requestParameters.order, requestParameters.pageLimit, requestParameters.after, requestParameters.before, requestParameters.search, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all asset types contained within the database
     * @summary Gets an asset tree by asset_id within the database
     * @param {ParameterApiGetAssetTreeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getAssetTree = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).getAssetTree(requestParameters.assetId, requestParameters.depth, requestParameters.showDeleted, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns parent, children, grandchildren etc. asset types contained within the database
     * @summary Gets an asset type tree by asset_type_id within the database - Route moved to Taxonomy Service
     * @param {ParameterApiGetAssetTypeTreeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getAssetTypeTree = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).getAssetTypeTree(requestParameters.assetTypeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all assets contained within the database
     * @summary Finds all assets within the database
     * @param {ParameterApiGetAssetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getAssets = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ParameterApiFp)(this.configuration).getAssets(requestParameters.assetId, requestParameters.assetTypeId, requestParameters.parentId, requestParameters.descendantsOf, requestParameters.projectId, requestParameters.showActive, requestParameters.showDeleted, requestParameters.sortBy, requestParameters.order, requestParameters.pageLimit, requestParameters.after, requestParameters.before, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get Calculation for given parameter_id and tag_id
     * @summary Get Calculation for given parameter_id and tag_id
     * @param {ParameterApiGetCalculationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getCalculation = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).getCalculation(requestParameters.parameterId, requestParameters.tagId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get Category for given parameter_id and tag_id
     * @summary Get Category for given parameter_id and tag_id
     * @param {ParameterApiGetCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getCategory = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).getCategory(requestParameters.parameterId, requestParameters.tagId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all assets contained within a single data set
     * @summary Get all assets contained within a dataset
     * @param {ParameterApiGetDataSetAssetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getDataSetAssets = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).getDataSetAssets(requestParameters.dataSetId, requestParameters.sortBy, requestParameters.order, requestParameters.pageLimit, requestParameters.after, requestParameters.before, requestParameters.showActive, requestParameters.showDeleted, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a single data set and a summary of if the data set structure is a valid representation of the template. The \"valid\" key returns a boolean indicating if the data set is in a valid state. The \"details\" key indicates where errors have occurred - \"incorrect_asset_count\" returns a list of placeholders with an incorrect number of assets assigned to the placeholder or placeholder and parent asset, \"missing_parameters\" returns a list of parameter types that are missing from a specified assets.
     * @summary Get a data set and its valid status
     * @param {ParameterApiGetDataSetValidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getDataSetValid = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).getDataSetValid(requestParameters.dataSetId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all data sets contained within the database
     * @summary Get all data sets
     * @param {ParameterApiGetDataSetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getDataSets = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ParameterApiFp)(this.configuration).getDataSets(requestParameters.templateId, requestParameters.projectId, requestParameters.sortBy, requestParameters.order, requestParameters.pageLimit, requestParameters.after, requestParameters.before, requestParameters.showActive, requestParameters.showDeleted, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Gets all entries, queryable by parameter id
     * @summary Get all entries
     * @param {ParameterApiGetEntriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getEntries = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ParameterApiFp)(this.configuration).getEntries(requestParameters.parameterId, requestParameters.assetId, requestParameters.projectId, requestParameters.sortBy, requestParameters.order, requestParameters.pageLimit, requestParameters.after, requestParameters.before, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Gets all revisions of an entry, arranged from newest to oldest
     * @summary Get all revisions associated with the specified entry_id
     * @param {ParameterApiGetEntryRevisionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getEntryRevisions = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).getEntryRevisions(requestParameters.entryId, requestParameters.sortBy, requestParameters.order, requestParameters.pageLimit, requestParameters.after, requestParameters.before, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * An endpoint for the permissions service OPA data load.
     * @summary Get asset data for the permissions service OPA load  (Application Admin only).
     * @param {ParameterApiGetOpaLoadAssetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getOpaLoadAssets = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ParameterApiFp)(this.configuration).getOpaLoadAssets(requestParameters.assetId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * An endpoint for the permissions service OPA data load.
     * @summary Get data sets data for the permissions service OPA load  (Application Admin only).
     * @param {ParameterApiGetOpaLoadDataSetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getOpaLoadDataSets = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ParameterApiFp)(this.configuration).getOpaLoadDataSets(requestParameters.dataSetId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * An endpoint for the permissions service OPA data load.
     * @summary Get parameter data for the permissions service OPA load  (Application Admin only).
     * @param {ParameterApiGetOpaLoadParametersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getOpaLoadParameters = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ParameterApiFp)(this.configuration).getOpaLoadParameters(requestParameters.parameterId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * An endpoint for the permissions service OPA data load.
     * @summary Get revisions data for the permissions service OPA load  (Application Admin only).
     * @param {ParameterApiGetOpaLoadRevisionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getOpaLoadRevisions = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ParameterApiFp)(this.configuration).getOpaLoadRevisions(requestParameters.revisionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Lists all options for an item type
     * @summary Get all options for an item type
     * @param {ParameterApiGetOptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getOptions = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).getOptions(requestParameters.itemTypeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns parameter by ID from the database.
     * @summary Finds parameter by ID
     * @param {ParameterApiGetParameterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getParameter = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).getParameter(requestParameters.parameterId, requestParameters.showDeleted, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all parameter type by ID from the database
     * @summary Finds all parameter_type by ID - Route moved to Taxonomy Service
     * @param {ParameterApiGetParameterTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getParameterType = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).getParameterType(requestParameters.parameterTypeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns metadata for parameter statistics
     * @summary Parameter metadata for count and qa stats
     * @param {ParameterApiGetParametersStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getParametersStatistics = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ParameterApiFp)(this.configuration).getParametersStatistics(requestParameters.assetId, requestParameters.assetType, requestParameters.parameterTypeId, requestParameters.projectId, requestParameters.projectParameter, requestParameters.categoryId, requestParameters.reportId, requestParameters.disciplineId, requestParameters.parameterSetId, requestParameters.sourceId, requestParameters.sourceTypeId, requestParameters.qaStatus, requestParameters.unitId, requestParameters.showActive, requestParameters.showDeleted, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get Report for given parameter_id and tag_id
     * @summary Get Report for given parameter_id and tag_id
     * @param {ParameterApiGetReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getReport = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).getReport(requestParameters.parameterId, requestParameters.tagId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns all units relating to the specified unit_type_id within the database. Units are grouped by their unit system.
     * @summary Finds a unit type\'s corresponding units - Route moved to Taxonomy Service
     * @param {ParameterApiGetUnitTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.getUnitType = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).getUnitType(requestParameters.unitTypeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update an asset. This endpoint can be used to update an asset name, or restore a  previously deleted asset. Note - name updates on assets that are asset sub type  instances is not allowed. Note -  you cannot restore an asset and update its name  simultaneously, to do this please send separate requests.
     * @summary Patch an existing asset
     * @param {ParameterApiPatchAssetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.patchAsset = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).patchAsset(requestParameters.assetId, requestParameters.patchAssetBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update an existing asset type. Note - requires Admin privileges.
     * @summary Patch an existing asset type (Application Admin only) - Route moved to Taxonomy Service
     * @param {ParameterApiPatchAssetTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.patchAssetType = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).patchAssetType(requestParameters.assetTypeId, requestParameters.patchAssetTypeBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update a data set. This endpoint can be used to update a data set name
     * @summary Patch an existing data set name
     * @param {ParameterApiPatchDataSetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.patchDataSet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).patchDataSet(requestParameters.dataSetId, requestParameters.patchDataSetBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update an existing parameter type. Note - updating global parameter types (scope = null) requires Admin privileges.
     * @summary Patch existing parameter type - Route moved to Taxonomy Service
     * @param {ParameterApiPatchParameterTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.patchParameterType = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).patchParameterType(requestParameters.parameterTypeId, requestParameters.patchParameterTypeBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates the status of the latest entry revisions
     * @summary Update entry revisions
     * @param {ParameterApiPatchRevisionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.patchRevisions = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).patchRevisions(requestParameters.patchRevisionBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates a new asset based on the input parameters
     * @summary Create a new asset
     * @param {ParameterApiPostAssetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.postAsset = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).postAsset(requestParameters.postAssetBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates new asset sub types. Note - requires Admin privileges.
     * @summary Creates new asset sub types (Application Admin only) - Route moved to Taxonomy Service
     * @param {ParameterApiPostAssetSubTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.postAssetSubTypes = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).postAssetSubTypes(requestParameters.assetTypeId, requestParameters.postAssetSubTypesBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates an asset type group. Note - requires Admin privileges.
     * @summary Create a new asset type group (Application Admin only) - Route moved to Taxonomy Service
     * @param {ParameterApiPostAssetTypeGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.postAssetTypeGroups = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).postAssetTypeGroups(requestParameters.postAssetTypeGroupsBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates an asset type. Note - requires Admin privileges.
     * @summary Create a new asset type (Application Admin only) - Route moved to Taxonomy Service
     * @param {ParameterApiPostAssetTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.postAssetTypes = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).postAssetTypes(requestParameters.postAssetTypesBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates a new parameter tag link for a calculation
     * @summary Create a new calculation link
     * @param {ParameterApiPostCalculationLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.postCalculationLink = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).postCalculationLink(requestParameters.parameterId, requestParameters.postCalculationLinkBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates a new parameter tag link for a category
     * @summary Create a new category link
     * @param {ParameterApiPostCategoryLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.postCategoryLink = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).postCategoryLink(requestParameters.parameterId, requestParameters.postCategoryLinkBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates a new data set based on the specified template. This endpoint creates the dataset and associates all the assets provided in the request body with it. The assets provided must be compliant with the asset_placeholders defined by the template. Any missing parameters from the assets, based on the parameter_placeholders defined in the template, are created automatically as part of this request.
     * @summary Create a new data set
     * @param {ParameterApiPostDataSetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.postDataSet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).postDataSet(requestParameters.putDataSetBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Adds existing assets to an existing data set. This also creates new parameters and links existing parameters associated with the new data set assets.
     * @summary Adds assets to an existing data set.
     * @param {ParameterApiPostDataSetAssetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.postDataSetAssets = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).postDataSetAssets(requestParameters.dataSetId, requestParameters.postDataSetAssetBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates an item type.  Note - creating a global item type requires Admin privileges.
     * @summary Create a new item type
     * @param {ParameterApiPostItemTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.postItemTypes = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).postItemTypes(requestParameters.postItemTypesBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates new parameter link for a disciplines
     * @summary Create new discipline links
     * @param {ParameterApiPostParameterDisciplinesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.postParameterDisciplines = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).postParameterDisciplines(requestParameters.parameterId, requestParameters.postParameterDisciplinesBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates new parameter types. Note - creating global parameter types (scope = null) requires Admin privileges.
     * @summary Creates new parameter types - Route moved to Taxonomy Service
     * @param {ParameterApiPostParameterTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.postParameterTypes = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).postParameterTypes(requestParameters.postParameterTypesBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates a list of new parameters
     * @summary Create a list of new parameters
     * @param {ParameterApiPostParametersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.postParameters = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).postParameters(requestParameters.postParametersBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates a new parameter tag link for a report
     * @summary Create a new report link
     * @param {ParameterApiPostReportLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.postReportLink = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).postReportLink(requestParameters.parameterId, requestParameters.postReportLinkBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Posts new unit types. This can only be done by an administrator
     * @summary Create new units types. Note - requires Admin privileges. Route moved to Taxonomy Service
     * @param {ParameterApiPostUnitTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.postUnitTypes = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).postUnitTypes(requestParameters.postUnitTypesBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Posts new units. This can only be done by an administrator
     * @summary Create new units. Note - requires Admin privileges. Route moved to Taxonomy Service
     * @param {ParameterApiPostUnitsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.postUnits = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).postUnits(requestParameters.postUnitsBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create or update one or more entries
     * @summary Create or update one or more entries
     * @param {ParameterApiPutEntriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.putEntries = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).putEntries(requestParameters.putEntriesBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Overwrites options for a given item_type by deleting the existing and adding new
     * @summary Sets options for given item_type - Note - creating options for a global item type requires Admin privileges.
     * @param {ParameterApiPutOptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterApi
     */
    ParameterApi.prototype.putOptions = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterApiFp)(this.configuration).putOptions(requestParameters.itemTypeId, requestParameters.putOptionsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ParameterApi;
}(base_1.BaseAPI));
exports.ParameterApi = ParameterApi;
